export default {
  currencyFormat: "#,###.##",
  thousandSeparator: ",",
  salesInvoiceEditor: {
    glAccountName: "GL сметка",
    glAccountNo: "GL номер на сметка",
  },
  title: {
    store: "Магазин",
    budget: "Бюджет",
    receivable: "Вземания",
    client: "Клиент",
    payable: "Задължения",
    inventory: "Склад",
    item: "Артикул",
    vendor: "Доставчик",
    masterData: "Основни данни",
    closeIncomeStatement: "Затвори отчет за доходите",
    storeRequisitionBatch: "Партида за заявка от магазин",
    generalPostingGroup: "Обща група за осчетоводяване",
    generalProductPostingGroup: "Обща група за осчетоводяване на продукти",
    generalBusinessPostingGroup: "Обща група за осчетоводяване на бизнес",
    clientPostingGroup: "Група за осчетоводяване на клиенти",
    vendorPostingGroup: "Група за осчетоводяване на доставчици",
    inventoryPostingGroup: "Група за осчетоводяване на склад",
    bankAccountPostingGroup: "Група за осчетоводяване на банкови сметки",
    inventoryReconciliationSetup: "Настройка на инвентаризационно съгласуване",
    expenseGeneralProductPostingGroup: "Група за осчетоводяване на общи разходи за продукти",
    expenseGeneralBusinessPostingGroup: "Група за осчетоводяване на общи бизнес разходи",
    vatPostingGroup: "Група за ДДС осчетоводяване",
    vatBusinessPostingGroup: "Група за ДДС осчетоводяване на бизнес",
    vatProductPostingGroup: "Група за ДДС осчетоводяване на продукти",
    vatPostingSetup: "Настройка на ДДС осчетоводяване",
    postingSetup: "Настройка на осчетоводяване",
    generalPostingSetup: "Обща настройка на осчетоводяване",
    inventoryPostingSetup: "Настройка на осчетоводяване на склад",
    signatureSetup: "Настройка на подпис",
    generalLedger: "Главна книга",
    chartOfAccount: "Сметкоплан",
    chartOfAccountCategory: "Категория на сметкоплан",
    chartOfAccountCategoryMenu: "COA категория",
    generalLedgerBudget: {
      title: "Импортиране от XLS",
      successImportData: "Данните са импортирани!",
    },
    balanceSheetConsolidation: {
      title: "Консолидация на баланс",
      titleReport: "Доклад за консолидация на баланс",
      excelFileID: "ID на Excel файл за консолидация на баланс",
      sheetFileID: "ID на Google Sheet за консолидация на баланс",
    },
    generalJournal: "Общ журнал",
    accountReconciliationJournal: "Журнал за съгласуване на сметки",
    newAccountReconciliationJournal: "Нов журнал за съгласуване на сметки",
    generalConfiguration: "Обща конфигурация",
    warehouseLocation: "Местоположение на склад",
    accountingPeriod: "Счетоводен период",
    inventoryPeriod: "Период на склад",
    bankAccount: "Банкова сметка",
    paymentTerm: "Условия за плащане",
    generalJournalBatch: "Партида общ журнал",
    numberSeries: "Серия номера",
    purchaseRequisitionBatch: "Партида за заявка за покупка",
    unitOfMeasurement: "Мерна единица",
    defaultUnitOfMeasurement: "Стандартна входяща мерна единица",
    baseUnitOfMeasurement: "Основна мерна единица",
    inputUnitOfMeasurement: "Входяща мерна единица",
    inputUnitOfMeasurementID: "ID на входяща мерна единица",
    inputUnitOfMeasurementName: "Име на входяща мерна единица",
    generalJournalTemplate: "Шаблон за общ журнал",
    user: "Потребител",
    purchaseRequest: "Заявка за покупка",
    purchaseOrder: "Поръчка за покупка",
    purchasing: "Покупки",
    purchaseReceiving: "Получаване на покупка",
    purchaseReceiveCanceled: "Отменено получаване на покупка",
    outstandingPurchaseRequest: "Неприключена заявка за покупка",
    vatBreakdown: "Разбивка на ДДС",
    purchaseRequestList: "Списък със заявки за покупка",
    storeRequisitionList: "Списък със заявки от магазин",
    storeRequisitionDetail: "Детайли за заявка от магазин",
    postedStoreRequisitionList: "Списък с осчетоводени заявки от магазин",
    storeRequisition: "Заявка от магазин",
    outstandingStoreRequisitionList: "Списък с неприключени заявки от магазин",
    outstandingPurchaseRequestList: "Списък с неприключени заявки за покупка",
    outstandingPurchaseRequestDetail: "Детайли за неприключена заявка за покупка",
    purchasePayableSetup: "Настройка на задължения по покупки",
    salesReceivableSetup: "Настройка на вземания по продажби",
    purchaseOrderDetail: "Детайли за поръчка за покупка",
    purchaseReceiptDetail: "Детайли за разписка за покупка",
    purchaseRequisitionTemplate: "Шаблон за заявка за покупка",
    purchaseRequisition: "Заявка за покупка",
    purchaseRequestDetail: "Детайли за заявка за покупка",
    purchaseInvoiceDetail: "Детайли за фактура за покупка",
    currency: "Валута",
    generalLedgerSetup: "Настройка на главна книга",
    inventorySetup: "Настройка на склад",
    documentFlow: "Документен поток",
    masterDocumentFlow: "Главен документен поток",
    documentFlowSequenceType: "Тип последователност на документен поток",
    purchaseInvoice: "Фактура за покупка",
    purchaseCheck: "Проверка на данни за покупка",
    itemLedgerEntry: "Запис в инвентарната книга",
    itemJournalBatch: "Партида инвентарен журнал",
    itemJournal: "Инвентарен журнал",
    physicalInventoryJournal: "Журнал за физически инвентар",
    vendorLedgerEntry: "Запис в книгата на доставчика",
    vendorLedgerEntryDetail: "Детайли за запис в книгата на доставчика",
    clientLedgerEntry: "Запис в книгата на клиента",
    clientLedgerEntryDetail: "Детайли за запис в книгата на клиента",
    bankAccountLedgerEntry: "Запис в книгата на банковата сметка",
    bankAccountLedgerEntryDetail: "Детайли за запис в книгата на банковата сметка",
    physicalInventoryLedgerEntry: "Запис във физическия инвентар",
    vatEntry: "Запис за ДДС",
    valueEntry: "Запис за стойност",
    itemApplicationEntry: "Запис за приложение на артикул",
    averageCostCalculationEntry: "Запис за изчисляване на средна стойност",
    generalJournalEntry: "Запис в общия журнал",
    postedDocuments: "Осчетоводени документи",
    postedPurchaseRequest: "Осчетоводена заявка за покупка",
    postedPurchaseOrder: "Осчетоводена поръчка за покупка",
    postedPurchaseReceipt: "Осчетоводена разписка за покупка",
    postedPurchaseInvoice: "Осчетоводена фактура за покупка",
    postedPurchaseCreditMemo: "Осчетоводен кредитен меморандум за покупка",
    postedSalesInvoice: "Осчетоводена фактура за продажба",
    postedSalesCreditMemo: "Осчетоводен кредитен меморандум за продажба",
    purchaseCreditMemo: "Кредитен меморандум за покупка",
    postedStoreRequisition: "Осчетоводена заявка от магазин",
    postedReceivableInvoice: "Осчетоводена фактура за вземания",
    entries: "Записи",
    outstandingStoreRequisition: "Неприключена заявка от магазин",
    adjustmentEntry: "Запис за корекция",
    generalLedgerEntry: "Запис в главната книга",
    paymentJournal: "Журнал за плащания",
    cashReceiptJournal: "Журнал за касови разписки",
    salesInvoice: "Фактура за продажба",
    salesInvoiceLine: "Ред във фактура за продажба",
    salesCreditMemo: "Кредитен меморандум за продажба",
    appliedEntries: "Приложени записи",
    reports: "Доклади",
    unapplyClientEntries: "Премахни приложени клиентски записи",
    applyClientEntries: "Приложи клиентски записи",
    unapplyVendorEntries: "Премахни приложени записи на доставчик",
    applyVendorEntries: "Приложи записи на доставчик",
    reverseTransaction: "Обърни транзакция",
    vendorBankAccount: "Банкова сметка на доставчик",
    reportSetting: "Настройка на доклад",
    itemJournalMasterTemplate: "Главен шаблон за инвентарен журнал",
    generalJournalMasterTemplate: "Главен шаблон за общ журнал",
    journalVoucher: "Журнален ваучер",
    paymentVoucher: "Платежен ваучер",
    receivableInvoice: "Фактура за вземания",
    accountReceivableAgingCreditCard: "Остаряване на вземания по кредитни карти",
    agingCreditCardReport: "Доклад за остаряване на кредитни карти",
    accountReceivablePaymentList: "Списък с плащания по вземания",
    accountReceivablePaymentListCard: "Списък с плащания по вземания по карти",
    accountReceivablePaymentListLedger: "Списък с плащания по вземания по книга",
    purchaseRequestApproval: "Одобрение на заявка за покупка",
    approval: "Одобрение",
    printOption: "Опция за печат",
    purchaseBookOption: "Опция за книга за покупки",
    inventoryReconciliation: "Инвентаризационно съгласуване",
    entryEditorChangeAccountNumber: "Промени номер на сметка",
    entryEditorChangeDescription: "Промени описание",
    entryEditorChangeBankAccount: "Change Bank Account",
    entryEditorChangesLog: "Дневник на промените",
    accountPayablePaymentList: "Списък с плащания по задължения",
    deleteBankAccountLedgerEntry: "Изтрий запис в книгата на банковата сметка",
    deleteBankAccountLedgerEntryDialog: "Диалог за изтриване на запис в книгата на банковата сметка",
    choose: "Избери",
    reopen: "Отвори отново",
    gle: "Главна книга на предприятието",
    baleDetail: "Детайли за BALE",
    bale: "BALE",
    chooseBaleEntry: "Избери запис за BALE",
    confirmReopenClosedEntry: "Потвърди повторно отваряне на затворен запис",
    confirmDeleteGLE: "Потвърди изтриване на GLE",
    confirmDeleteBaleDetail: "Потвърди изтриване на детайли за BALE",
    confirmDeleteBale: "Потвърди изтриване на BALE",
    documentApproval: "Одобрение на документ",
    deletePostedInvoice: "Изтрий осчетоводена фактура",
    movePurchaseInvoiceLines: "Премести редове от фактура за покупка",
    purchaseRequestApprovalDetail: "Детайли за одобрение на заявка за покупка",
    purchaseOrderApprovalDetail: "Детайли за одобрение на поръчка за покупка",
    storeRequestApprovalDetail: "Детайли за одобрение на заявка от магазин",
    withdrawDocumentApproval: "Оттегли одобрение на документ",
    changeStatus: "Промени статус",
    changeStatusPurchaseRequisition: "Промени статус на заявка за покупка",
    cle: "CLE",
    vle: "VLE",
    cleDetail: "Детайли за CLE",
    vleDetail: "Детайли за VLE",
    chooseCleEntry: "Избери запис за CLE",
    chooseVleEntry: "Избери запис за VLE",
    confirmDeleteCleDetail: "Потвърди изтриване на детайли за CLE",
    confirmDeleteCle: "Потвърди изтриване на CLE",
    confirmDeleteVleDetail: "Потвърди изтриване на детайли за VLE",
    confirmDeleteVle: "Потвърди изтриване на VLE",
    deleteClientLedgerEntry: "Изтрий CLE",
    deleteClientLedgerEntryDialog: "Диалог за изтриване на CLE",
    deleteVendorLedgerEntry: "Изтрий VLE",
    deleteVendorLedgerEntryDialog: "Диалог за изтриване на VLE",
    updateWitholdingTax: "Актуализирай удържан данък",
    adjustmentTools: "Инструменти за корекция",
    directExpenseGenBusPostGroup: "Група за осчетоводяване на директни разходи (бизнес)",
    directExpenseGenProdPostGroup: "Група за осчетоводяване на директни разходи (продукт)",
    directExpenseAdjustmentAccount: "Сметка за корекция на директни разходи",
    defaultDirectExpenseGenBusPostGroup: "Стандартна група за директни разходи (бизнес)",
    custPostGroup: "Клиентска група за осчетоводяване",
    vendorPostGroup: "Група за осчетоводяване на доставчици",
    journalTemplate: "Шаблон на журнал",
    noSeries: "Серия номера",
    defaultLocation: "Стандартно местоположение",
    prefix: "Префикс",
    startingNumber: "Начален номер",
    endingNumber: "Краен номер",
    lastNumberUsed: "Последен използван номер",
    lengthOfNumber: "Дължина на номера",
    includeYear: "Включи година",
    includeMonth: "Включи месец",
    includeDate: "Включи дата",
    isEditable: "Може да се редактира",
    branch: "Клон",
    bankAccountNo: "Номер на банкова сметка",
    virtualAccountNo: "Номер на виртуална сметка",
    allowPostingFrom: "Позволи осчетоводяване от",
    allowPostingTo: "Позволи осчетоводяване до",
    receivableAccount: "Сметка вземания",
    receivableAccountNo: "Номер на сметка вземания",
    payableAccount: "Сметка задължения",
    balanceAccount: "Сметка баланс",
    accountCategory: "Категория на сметка",
    accountType: "Тип сметка",
    directPost: "Директно осчетоводяване",
    blocked: "Блокирано",
    vatPercentage: "ДДС процент",
    startingDate: "Начална дата",
    closed: "Затворено",
    endingDate: "Крайна дата",
    dueDateCalc: "Изчисляване на падежна дата",
    debitAmount: "Сума дебит",
    creditAmount: "Сума кредит",
    amount: "Сума",
    isApplied: "Приложено ли е",
    appliedSalesInvoiceId: "ID на приложена фактура за продажба",
    appliedSalesCreditMemoId: "ID на приложена кредитно известие за продажба",
    cashDeskMovementId: "ID на движение в каса",
    userPostingSetup: "Настройка на публикации от потребителя",
    purchaseInvoiceApprovalDetail: "Детайли за одобрение на фактура за покупка",
    adjustSingleEntry: "Настройка на единичен запис",
    adjustSOH: "Настройка на SOH",
    adjustCostItemEntries: "Настройка на елементи за разходи",
    documentAttachment: "Прикачен документ",
    recallJournal: "Журнал за спомени",
    reverseJournal: "Обратен дневник",
    inventoryAccountBalanceDetail: "Детайли на баланса на инвентарната сметка",
    recalled: "Отменен",
    changeClient: "Смяна на клиент",
    itemCostPerLocation: "Цена на артикул по локация",
    integration: "Интеграция",
    interDepartmentTransferDetail: "Детайли за прехвърляне между отдели",
    revaluationJournalAllItems: "Журнал за преоценка Всички артикули",
    revertPostedSalesInvoice: "Върни публикувана фактура за продажба",
    generalLedgerEntryChangesLogs: "Логове на промените в главната книга",
    changeItem: "Промени {item}",
    itemJournalLog: "Журнал на артикули",
    changesLogs: "Журнал на промените",
    cancelledPurchaseReceipts: "Отменени покупки",
    newPaymentJournal: "Нов платежен журнал",
    newCashReceiptJournal: "Нов журнал за касови приходи",
    itemsWithIncorrectCosts: "Артикули с некоректни цени",
    ve: "ВЕ",
    chooseVeEntry: "Изберете VE вход",
    confirmDeleteVe: "Потвърдете изтриването на VE",
    deleteValueEntry: "Изтрий VE",
    deleteValueEntryDialog: "Изтрий стойността",
    deleteGeneralJournalEntryDialog: "Изтрий общ журнал",
    selfBilledInvoice: "Самостоятелно фактуриране",
    taxIntegrationLog: "Лог на данъчната интеграция",
    updateStoreRequisition: "Обнови статуса на заявката за магазин",
    printoutLayout: "Оформление на печат",
    adjustPostingDate: "Настройка на дата на публикуване",
    invoiceEmailLog: "Лог на имейли с фактури",
    inventoryPostingGroups: "Групи за запис на инвентар",
    entryEditorChangeAccountNumberAndDescription: "Промяна на номер на акаунт и описание",
    revertPostedPurchaseInvoice: "Върни публикувана фактура за покупка",
    changeLineStatus: "Промяна на статус на линия",
    dimension: "Размер",
    dimensionValueType: "Тип стойност на измерение",
    dimensionValue: "Стойност на измерение",
    dimensionOption: "Опция за размер",
    coaDimension: "Измерение на COA",
    coaDimensionOptions: "Опции за размер на COA",
    coaDimensionMatrix: "Матрица на размерите на COA",
    updateCoaDimensionMapping: "Актуализиране на картата на измеренията на COA",
    defaultDimension: "Стандартен размер",
    dimensionRule: "Правило за размери",
    dimensionRules: "Правила за размери",
    allowedDimensionValues: "Разрешени стойности на размерите",
    documentDimension: "Размер на документа",
    approvalDocumentWithdrawal: "Оттегляне на одобрителен документ",
    deleteEntries: "Изтрий записи",
    confirmDeletePurchaseInvoice: "Потвърдете изтриването на фактурата за покупка",
    storeRequisitionTemplate: "Шаблон за заявка в магазина",
    deletePostedMemo: "Изтрий публикувана бележка",
    entryEditorChangeDimensionSet: "Смяна на набор от размери",
    revertPostedPurchaseCreditMemo: "Върни публикуван кредитен мемо за покупка",
    ytdAddAdditionalYear: "Добави допълнителна година (Сравнение на YTD отчети)",
    revertPostedInterDepartmentTransfer: "Revert Posted Inter Department Transfer",
    depositAccountPostingGroup: "Група за запис на депозитни сметки",
    depositAccount: "Депозитна сметка",
    depositAccountLedgerEntry: "Запис в книга на депозитен акаунт",
    depositAccountLedgerEntryDetail: "Детайли за запис в регистъра на депозитни сметки",
    deleteDepositAccountLedgerEntry: "Изтрий DALE",
    deleteDepositAccountLedgerEntryDialog: "Изтрий запис в главната книга на депозитната сметка",
    daleDetail: "Детайли на DALE",
    dale: "ДА",
    chooseDaleEntry: "Изберете запис на Дейл",
    confirmDeleteDaleDetail: "Потвърдете изтриването на детайла DALE",
    confirmDeleteDale: "Потвърдете изтриването на DALE",
    dimensionLevel: "Ниво на размер",
    interDepartmentTransferApprovalDetail: "Детайли за одобрение на прехвърляне между отдели",
    generalBudgetEntry: "Обща бюджетна статия",
    generalBudgetJournal: "Общ бюджетен журнал",
    reportByDimension: "Доклад по измерение",
    profitAndLossBudgetSource: "Източник на бюджет за печалба и загуба",
    deleteSelectedInvoices: "Изтрий избраните фактури",
    confirmDimensionSet: "Потвърдете набора от размери",
    cashFlowBudget: "Бюджет на паричния поток",
    interDepartmentTransfer: "Прехвърляне между отдели",
    interDepartmentTransferBatch: "Партида за прехвърляне между отдели",
    expenseAllocation: "Разпределение на разходите",
    newReconciliationJournal: "Нов журнал за съгласуване",
  },
  word: {
    entryNo: "Номер на запис",
    chooseThePrintingPageSize: "Изберете размера на страницата за печат",
    changedTo: "Към",
    chooseThePurchaseBookOption: "Изберете опция за книга за покупки",
    importRejected: "Импортът е отхвърлен. Поправете тези редове и опитайте отново.",
    importWithReservationSuccess: "Импортни {фактури} фактури и {резервации} резервации.",
  },
  main: {
    search: "Търсене",
    account: "Сметка",
    interimAccount: "Временна сметка",
  },
  form: {
    purchaseOrders: "Поръчки за покупка",
    purchaseRequest: "Заявка за покупка",
    outstandingPurchaseRequest: "Неприключена заявка за покупка",
    receiving: "Получаване",
    info: "Информация",
    vendors: "Доставчици",
    items: "Артикули",
    breakdowns: "Разбивки",
  },
  button: {
    directExpense: "Задай като директен разход",
    correction: "Направи корекция на фиксирано прилагане",
    setVendor: "Задай доставчик",
    getLastDirectCost: "Вземи последна директна цена",
    preview: "Преглед",
    resetEntry: "Нулирай всички записи",
    manageBankAccount: "Управлявай банкова сметка",
    viewDetail: "Виж детайли",
    viewAppliedEntries: "Приложени записи",
    viewEntries: "Виж записи",
    previewUndoReceipt: "Преглед на отмяна на разписка",
    cancelReceipt: "Отмени разписка",
    previewCancelReceipt: "Преглед на отмяна на разписка",
    delete: "Изтрий",
    createCreditMemo: "Създай коригиращ кредитен меморандум",
    calculateInventory: "Изчисли склад",
    refreshUnitCost: "Обнови единична цена",
    upload: "Качи",
    download: "Изтегли",
    downloadTemplate: "Изтегли шаблон",
    previewData: "Преглед на данни",
    import: "Импорт",
    view: "Преглед",
    new: "Нов",
    edit: "Редактирай",
    ok: "ОК",
    cancel: "Отказ",
    save: "Запази",
    recalculateAverageCost: "Пресметни средна цена отново",
    add: "Добави",
    choose: "Избери",
    print: "Печат",
    post: "Осчетоводи",
    unpost: "Деосчетоводи",
    previewPost: "Преглед на осчетоводяване",
    printSupplierComparison: "Печат на сравнение на доставчици",
    insertFromTemplate: "Вмъкни от шаблон",
    applyEntries: "Приложи записи",
    unapplyEntries: "Премахни прилагане на записи",
    process: "Обработи",
    processToPo: "Обработи до ПО",
    reject: "Отхвърли",
    decline: "Откажи",
    approve: "Одобри",
    submitApproval: "Изпрати за одобрение",
    reopen: "Отвори отново",
    release: "Пусни",
    select: "Избери",
    close: "Затвори",
    move: "Премести",
    clear: "Изчисти",
    saveChange: "Запази промените",
    saveAsTemplate: "Запази като шаблон",
    addNewTemplate: "Добави нов шаблон",
    AddFromReceipt: "Добави от разписка",
    reset: "Нулирай",
    apply: "Приложи",
    addFilter: "Добави филтър",
    navigate: "Навигирай",
    reverse: "Обърни",
    forceClose: "Принудително затвори",
    receiveAll: "Задай получаване на всичко",
    ClearReceive: "Изчисти получаването",
    closePeriod: "Затвори период",
    reopenPeriod: "Отвори период отново",
    reopenPeriodForce: "Принудително отвори период отново",
    closeMonthPeriod: "Затвори месец",
    reopenMonthPeriod: "Отвори месец отново",
    reopenMonthPeriodForce: "Принудително отвори месец отново",
    closeYearPeriod: "Затвори година",
    reopenYearPeriod: "Отвори година отново",
    viewPrice: "Виж цена",
    newItem: "Нов артикул",
    splitItem: "Раздели артикул",
    postAndPrint: "Осчетоводи и печатай",
    vendorEntries: "Записи на доставчик",
    postBatch: "Осчетоводи партида",
    getPostedSalesInvoice: "Вземи осчетоводена фактура за продажба",
    setQtyToZero: "Задай количество на нула",
    showOpenOnly: "Показвай само отворени",
    history: "История",
    released: "Пуснато",
    deleted: "Изтрито",
    showData: "Покажи данни",
    newItemFromPR: "Нов артикул от PR",
    setReconciled: "Задай като съгласувано",
    unsetReconciled: "Премахни съгласуване",
    downloadToGSheet: "Към GSheet",
    downloadToExcel: "Към Excel",
    downloadToPDF: "Към PDF",
    goToSetup: "Към настройките",
    goToInvReconSetup: "Към настройките за съгласуване на склад",
    goToInventorySetup: "Към настройките на склад",
    applyEntriesFromInvoice: "Приложи записи от фактура",
    applyEntriesFromCreditMemo: "Приложи записи от кредитен меморандум",
    submit: "Изпрати",
    submitForApproval: "Изпрати за одобрение",
    deleteAll: "Изтрий всички",
    approvalDetail: "Детайли за одобрение",
    delegate: "Делегирай",
    withdraw: "Оттегли",
    previewAdjustCostEntries: "Преглед на коригиращи записи за цена",
    adjustCostEntries: "Коригирай записи за цена",
    splitInvoice: "Раздели фактура",
    selectAll: "Избери всички",
    unselectAll: "Премахни избора на всички",
    back: "Назад",
    next: "Напред",
    confirm: "Потвърди",
    recall: "Върни обратно",
    refresh: "Обнови",
    viewAccount: "Виж сметка",
    viewDimension: "Виж размер",
    undoForceClose: "Отмени принудително затваряне",
    adjustValueEntryAmount: "Коригирай сума на запис за стойност",
    updateLowestUnitCostVendorComparison: "Обнови единична цена с най-ниска цена на доставчик",
    importHOAInvoice: "Импортирай HOA фактура",
    deleteBy: "Изтрий от {f}",
    deleteByIleId: "Изтриване по ILE ID",
    deleteByDocumentNo: "Изтрий по номер на документа",
    newSet: "Нов комплект",
    invoicedOnly: "Само фактурирано",
    updateStatus: "Обнови статус",
    undo: "Отмяна",
    clearAll: "Изчисти всичко",
    recalculateInventory: "Пресметни инвентара",
    revert: "Върни",
    lineStatusFilter: "Филтър за статус на линия",
    create: "Създай",
    selectDimensionValues: "Изберете стойности на измерението",
    includeClosedInvoice: "Включи затворена фактура",
    includeClosedEntry: "Включи затворен запис",
    addDimension: "Добави размер",
    approvalNotes: "Забележки за одобрение",
    importInvoiceWithReservation: "Импорт на фактура с резервация",
    readSheet: "Прочети листа",
    newLine: "Нова линия",
    generateAccrual: "Генерирай начисление",
    googleSheetJournalFormat: "Google Таблица (Формат на дневник)",
    excelJournalFormat: "Ексел (Журнален формат)",
    journalExcelTemplate: "Шаблон на Excel (Формат на журнал)",
    printReceipt: "Разпечатай разписка",
    postAllBatch: "Публикувай всички партиди",
    deleteAllBatch: "Изтрий всички партиди",
  },
  excel: {
    excel: "Excel",
    upload: "Качване",
    uploadInsert: "Качване (Вмъкване)",
    uploadUpdate: "Качване (Актуализация)",
    download: "Изтегляне",
    downloadTemplate: "Изтегли шаблон",
    preview: "Преглед на данни",
    import: "Импорт",
    cancel: "Отказ",
    importSuccess: "Импортът е успешен",
    importFailed: "Импортът неуспешен",
    downloadFailed: "Неуспешно изтегляне на данните",
    parseFailed: "Неуспешен анализ на Excel файла",
    noValidRows: "Няма валидни редове за импортиране",
    noDataRows: "Файлът няма редове с данни",
    invalidFileType: "Поддържат се само файлове .xlsx",
    fileTooLarge: "Файлът трябва да е под {size}MB",
    showingTruncated: "Показани {limit} от {total} реда — всички {total} реда ще бъдат импортирани.",
    missingColumns: "Импортирането е блокирано — липсват очаквани колони: {columns}. Моля, изтеглете шаблона отново.",
  },
  select: {
    base: "Избери {f}",
  },
  reports: {
    allVendor: "Всички доставчици",
    noVendor: "Няма доставчик",
    vendorList: "Списък с доставчици",
    earliestPostingDate: "Най-ранна дата на осчетоводяване",
    latestPostingDate: "Най-късна дата на осчетоводяване",
    selectVendor: "Избери доставчик",
    detailLocationSummary: "Детайлен обобщен отчет за местоположение",
    pnlFileID: "ID на файл за печалба и загуба {f}",
    exportPnl: "Печалба и загуба {f}",
    pnlID: "ID на печалба и загуба {f}",
    downloadToExcel: "Изтегли към Excel",
    profitAndLossCurrentMonthConsolidationExcelFileID: "ID на Excel файл за консолидирана печалба и загуба за текущия месец",
    profitAndLossYTDConsolidationExcelFileID: "ID на Excel файл за консолидирана печалба и загуба YTD",
    profitAndLossYTDSummaryExcelFileID: "ID на Excel файл за обобщена печалба и загуба YTD",
    balanceSheetExcelFileID: "ID на Excel файл за баланс",
    dailyFlashCostExcelFileID: "ID на Excel файл за дневни разходи",
    DRRExcelFileID: "ID на Excel файл за DRR",
    FBMealCoverExcelFileID: "ID на Excel файл за FB Meal Cover",
    profitAndLossCurrentMonthConsolidationGoogleSheetFileID: "ID на Google Sheet за консолидирана печалба и загуба за текущия месец",
    profitAndLossYTDConsolidationGoogleSheetFileID: "ID на Google Sheet за консолидирана печалба и загуба YTD",
    profitAndLossYTDSummaryGoogleSheetFileID: "ID на Google Sheet за обобщена печалба и загуба YTD",
    balanceSheetGoogleSheetFileID: "ID на Google Sheet за баланс",
    dailyFlashCostGoogleSheetFileID: "ID на Google Sheet за дневни разходи",
    DRRGoogleSheetFileID: "ID на Google Sheet за DRR",
    FBMealCoverGoogleSheetFileID: "ID на Google Sheet за FB Meal Cover",
    startInventoryAccountNumber: "Начален номер на сметка за склад",
    endInventoryAccountNumber: "Краен номер на сметка за склад",
    accountPayableInterim: "Временни задължения",
    inventoryDiscrepancyReport: "Доклад за разлики в склада",
    inventoryFoodDiscrepancy: "Разлики в хранителния склад",
    inventoryBeverageDiscrepancy: "Разлики в склад за напитки",
    invAccBalanceSOHDiscrepancy: "Разлика между баланс на склад и SOH",
    financialReport: "Финансов отчет",
    accountPayableReport: "Отчет за задължения",
    accountReceivableReport: "Отчет за вземания",
    inventoryReport: "Отчет за склад",
    frontOfficeReport: "Отчет за рецепция",
    balanceSheet: "Баланс",
    trialBalance: "Пробен баланс",
    profitAndLoss: "Печалба и загуба",
    profitAndLossYTDSummary: "Обобщена печалба и загуба YTD",
    profitAndLossCurrentMonthConsolidation: "Консолидирана печалба и загуба за текущия месец",
    profitAndLossYTDConsolidation: "Консолидирана печалба и загуба YTD",
    accountPayableAging: "Остаряване на задължения",
    accountPayableInterimAging: "Остаряване на временни задължения",
    accountPayablePaymentList: "Списък с плащания по задължения",
    accountReceivableAging: "Остаряване на вземания",
    accountReceivableAgingCard: "Остаряване на вземания по карти",
    accountReceivablePaymentList: "Списък с плащания по вземания",
    accountReceivablePaymentListCard: "Списък с плащания по вземания по карти",
    accountReceivablePaymentListLedger: "Списък с плащания по вземания по книга",
    inventoryAccountBalanceDetail: "Детайли за баланс на склад",
    stockOnHand: "Наличност на склад",
    topPurchaseItem: "Топ артикул за покупка",
    topPurchaseByVendor: "Топ покупки по доставчик",
    topPurchaseByVendorReport: "Доклад за топ покупки по доставчик",
    vendorReport: "Доклад за доставчик",
    dailyFlashCost: "Дневни разходи",
    slowMovingInventory: "Бавно движещ се склад",
    itemExpense: "Разходи за артикули",
    receivingReport: "Доклад за получаване",
    inventoryReconciliation: "Съгласуване на склад",
    itemReorder: "Пренареждане на артикули",
    outstandingPurchaseOrder: "Неприключена поръчка за покупка",
    forceClosedPurchaseOrder: "Принудително затворена поръчка за покупка",
    purchasingReport: "Отчет за покупки",
    inventoryMovementReport: "Доклад за движение на склад",
    guestAccountBalance: "Баланс на гост акаунт",
    FOClosingCashier: "Затваряне на каса рецепция",
    POSClosingCashier: "Затваряне на каса POS",
    dailyRevenueReport: "Дневен отчет за приходи",
    FBMealCover: "FB Meal Cover",
    incomeAudit: "Одит на приходи",
    budgetRevenue: "Бюджетни приходи",
    budgetStatistic: "Бюджетна статистика",
    showGuestAccountName: "Покажи име на гост/акаунт",
    showSalesPersonName: "Покажи име на търговец",
    showContactName: "Покажи име на контакт на клиент",
    agingDate: "Дата на остаряване",
    discrepancyReport: "Доклад за разлики",
    discrepancy: "Разлика",
    agingBy: "Остаряване по",
    arAgingReport: "Отчет за остаряване на вземания",
    cardAgingReport: "Отчет за остаряване на карти",
    arAgingAccountSetup: "Настройка на акаунт за остаряване на вземания",
    arAgingAccountSetupNotes: "Използва се в отчет за разлики в баланса на остаряване на вземания",
    apAgingAccountSetup: "Настройка на акаунт за остаряване на задължения",
    apAgingAccountSetupNotes: "Използва се в отчет за разлики в баланса на остаряване на задължения",
    arAgingDiscrepancyReport: "Доклад за разлики в остаряване на вземания",
    arAgingDiscrepancy: "Разлика в остаряване на вземания",
    apAgingDiscrepancyReport: "Доклад за разлики в остаряване на задължения",
    apAgingDiscrepancy: "Разлика в остаряване на задължения",
    bankAccountAgingDiscrepancyReport: "Доклад за разлики в остаряване на банкови сметки",
    bankAccountAgingDiscrepancy: "Разлика в остаряване на банкови сметки",
    arAgingCardAndLedger: "Остаряване на вземания по карти и книга",
    arAgingCardAndLedgerReport: "Доклад за остаряване на вземания по карти и книга",
    TBSummaryGoogleSheetFileID: "ID на файл в Google Sheet с обобщение на пробен баланс",
    TBSummaryExcelFileID: "ID на Excel файл с обобщение на пробния баланс",
    gsheetTemplateIsNotConfiguredYet: "Шаблонът Ghseet все още не е конфигуриран",
    excelTemplateIsNotConfiguredYet: "Шаблонът на Excel все още не е конфигуриран",
    downloadAsMacro: "Изтегли като макро",
    balanceSheetYTDSummary: "Обобщение на баланса от началото на годината",
    accountScheduleConsolidation: "Консолидация на графика на акаунта",
    accountScheduleConsolidationReport: "Доклад за консолидиране на графика на акаунта",
    accountScheduleConsolidationExcelFileID: "ID на Excel файл за консолидиране на график на акаунта",
    accountScheduleConsolidationGoogleSheetFileID: "ID на файл Google Sheet за консолидиране на график на акаунта",
    notAvailableForPreview: "{item} не е наличен за преглед. Моля, изтеглете отчета, за да видите тези данни.",
    trialBalanceYTD: "Пробен баланс до момента",
    itemConsumptionReport: "Доклад за потребление на артикули",
    interfaceJournal: "Журнал на интерфейса",
    includeDimension: "Включи колони за измерения",
    useReceivableDateAging: "Използвайте дата на задължения / дата на запис",
    accountPayableInterimIsNotConfiguredYet: "Временната сметка за задължения не е конфигурирана. Моля, настройте я в Настройки на отчета.",
    accountPayableInterimAccountNotFound: "Конфигурираният междинен акаунт за задължения не беше намерен в счетоводния план.",
    cashFlowExcelFileID: "ИД на Excel файл за паричен поток",
    cashFlowYTDSummaryExcelFileID: "Идентификатор на Excel файл за обобщение на паричния поток от началото на годината",
    excelTemplateNotUploaded: "Шаблонът на Excel все още не е качен. Качете го в Основни данни > Обща конфигурация > Настройки на отчета.",
    cashFlow: "Паричен поток",
    cashFlowYTDSummary: "Обобщение на паричния поток от началото на годината",
    cashFlowNotConfigured: "Не е конфигурирано измерение на паричния поток. Добавете такова в Настройки на главната книга → Доклад по измерение → Паричен поток.",
    actualCurrentMonth: "Текущ месец",
    budgetCurrentMonth: "Бюджет Текущ Месец",
    actualLastMonth: "Последен месец",
    actualLastYear: "Последна година",
    actualYTDCurrentMonth: "Текущ месец до момента",
    budgetYTDCurrentMonth: "Бюджет до момента Текущ месец",
    actualYTDLastYear: "Реален YTD миналата година",
    cashFlowByDepartmentExcelFileID: "ID на Excel файл за паричен поток по отдел",
    cashFlowByDepartment: "Паричен поток по отдели",
    cashFlowByDepartmentNotConfigured: "Конфигурирайте две измерения в Настройки на главната книга → Доклад по измерение → Паричен поток по отдел: първото е ос на редовете, второто - ос на колоните.",
    cashFlowMonthToDate: "Месец до днешна дата",
    cashFlowYearToDate: "От началото на годината",
    cashFlowUnassigned: "Неопределен",
    cashFlowTotal: "ОБЩО",
  },
  status: {
    pleaseWait: "Моля, изчакайте...",
    loadingpleaseWait: "Зареждане... Моля, изчакайте",
    trialBalanceDetail: {
      generatingData: "Генерирането на детайли за пробния баланс е в процес. Моля, изчакайте; това може да отнеме известно време. Можете да затворите раздела/прозореца или да се пренасочите към друга страница; процесът ще продължи да работи.",
      readyForDownload: "Всички Excel файлове за периода са готови за изтегляне",
      sendEmail: "и изпратете на имейл:",
      exclusiveDownload: "Детайлните резултати от пробния баланс не са налични за уеб показване и могат да бъдат достъпни само чрез изтегляне на файл. <br> За набори от данни с повече от 5 000 реда, моля, използвайте опцията за изтегляне на Excel.",
      gsheeRowLimitExceeded: "Лимитът на редовете за Google Sheets е надвишен. Моля, изтеглете файла като Excel документ.",
      downloadPartialMessage: "Файлът за изтегляне на пробния баланс ще бъде разделен по месеци. Моля, не затваряйте браузъра по време на този процес.",
      periodStarted: "Генерирането на Excel файл за периода от {p} е започнало.",
      inProgressFile: "Генериране на файл в процес:",
      willSendToEmail: "Файлът с детайли на пробния баланс в момента се генерира и ще бъде изпратен на {email} след завършване.",
      csvOptionDownload: "За периоди над един месец, моля, използвайте CSV изтегляне.",
      rowLimitExceeded: "This range has {rows} ledger entries (max {max}). Narrow the date range or use the CSV download.",
    },
    purchaseReceivingDetail: {
      generatingData: "Генерирането на детайли за отчета за получаване е в процес. Моля, изчакайте; това може да отнеме известно време. Можете да затворите раздела/прозореца или да се пренасочите към друга страница; процесът ще продължи да работи.",
      readyForDownload: "Файлът с детайли за отчета за получаване вече е наличен за изтегляне: ",
      sendEmail: "и изпратете на имейл:",
      exclusiveDownload: "Детайлните резултати от отчета за получаване не са налични за уеб показване и могат да бъдат достъпни само чрез изтегляне на файл. <br> За набори от данни с повече от 5 000 реда, моля, използвайте опцията за изтегляне на Excel.",
      gsheeRowLimitExceeded: "Лимитът на редовете за Google Sheets е надвишен. Моля, изтеглете файла като Excel документ.",
    },
    commonReportDetail: {
      generatingData: "Генерирането на {f1} детайли е в процес. Моля, изчакайте; това може да отнеме известно време. Можете да затворите раздела/прозореца или да се пренасочите към друга страница; процесът ще продължи да работи.",
      readyForDownload: "Файлът с детайли за {f1} вече е наличен за изтегляне: ",
      sendEmail: "и изпратете на имейл:",
      exclusiveDownload: "Детайлните резултати за {f1} не са налични за уеб показване и могат да бъдат достъпни само чрез изтегляне на файл. <br> За набори от данни с повече от {f2} реда, моля, използвайте опцията за изтегляне на Excel.",
      gSheetRowLimitExceeded: "Лимитът на редовете за Google Sheets е надвишен. Моля, изтеглете файла като Excel документ.",
    },
    disabledDueToQuantityReceived: "Деактивирано поради наличието на получено количество",
    exclusiveDownload: "Подробните резултати не са налични за уеб показване. Моля, използвайте опцията за изтегляне, за да видите пълните детайли.",
    willSendToEmail: "Файлът в момента се генерира и ще бъде изпратен на {email} след завършване.",
  },
  confirm: {
    processing: "Обработка, моля изчакайте",
    noAccess: "Няма достъп",
    correctionTitle: "Корекция на фиксирано прилагане",
    correction: "Сигурни ли сте, че искате да направите корекция за {f}",
    receiveAllHeader: "Задай да се получи всичко",
    receiveAll: "Задай да се получи цялото количество?",
    receiveAllFailed: "Неуспешно задаване на получаване на всичко",
    noEntryPreviewPost: "Този пост не е генерирал никакви записи",
    deleteHeader: "Изтрий {f}",
    deleteCanUndo: "Сигурни ли сте, че искате да изтриете {f}?",
    delete: "Сигурни ли сте, че искате да изтриете {f}? Този процес не може да бъде отменен.",
    deleteBatch: "Сигурни ли сте, че искате да изтриете {f1} реда от {f2}? Този процес не може да бъде отменен.",
    deleteSuccess: "{f} беше изтрит успешно!",
    deleteFailed: "Грешка, не може да се изтрие {f}.",
    updateSuccess: "{f} беше запазен успешно!",
    updateFailed: "Грешка, не може да се запази {f}.",
    printFailed: "Грешка, не може да се отпечата {f}.",
    importSuccess: "{f} беше импортиран успешно!",
    importFailed: "Грешка, не може да се импортира {f}.",
    dialogClosing: "Диалогът се затваря",
    releaseSuccess: "{f} беше пуснат успешно!",
    releaseFailed: "Грешка, не може да се пусне {f}.",
    reopenSuccess: "{f} беше отворен отново успешно!",
    reopenFailed: "Грешка, не може да се отвори отново {f}.",
    reopenFailedAlreadyProcessed: "Грешка, не може да се отвори отново {f}. Поръчката вече е получена.",
    closeSuccess: "{f} е затворен успешно!",
    closeFailed: "Грешка, не може да се затвори {f}.",
    restore: "Сигурни ли сте, че искате да възстановите {f}?",
    restoreHeader: "Възстанови {f}",
    restoreFailed: "Грешка, не може да се възстанови {f}.",
    restoreSuccess: "{f} е възстановен успешно!",
    setToNonDirectExpense: "Сигурни ли сте, че искате да зададете като Непряка Разход {f}?",
    setToNonDirectExpenseHeader: "Настройка на непряка разходна категория {f}",
    setToNonDirectExpenseFailed: "Грешка, не може да се зададе като непряка разходна {f}.",
    setToNonDirectExpenseSuccess: "{f} беше успешно зададено като непряка разход!",
    applyEntriesSuccess: "Записите са приложени успешно!",
    applyEntriesFailed: "Грешка, неуспешно прилагане на записи {f}.",
    unapplyEntriesSuccess: "Записите бяха успешно отменени!",
    unapplyEntriesFailed: "Грешка, неуспешно премахване на записи {f}.",
    reverseEntriesSuccess: "Записите бяха успешно обърнати!",
    reverseEntriesFailed: "Грешка, неуспешно обръщане на записи {f}.",
    postedSuccess: "{f} е публикувано успешно!",
    postedFailed: "Грешка, не може да се публикува {f}.",
    postedFailedUnitCostZero: "Грешка, не може да се публикува {f}. Цената на единица не може да е 0.",
    postHaveNegativeAdjustment: "Внимание, публикуването ще добави отрицателна корекция. Продължавате?",
    processSuccess: "{f} е обработен успешно!",
    processedItems: "- {f1} ({f2}), количество {f3} {f4}",
    processAlready: "Тези артикул(и) вече са обработени като ПО:<br/>{f}",
    hasZeroUnitCost: "Някои артикули имат нулева цена. Моля, проверете отново!",
    hasZeroQuantity: "Някои артикули имат нулево количество. Моля, проверете отново!",
    hasZeroStockOnHand: "Някои артикули нямат наличност. Моля, проверете отново!",
    hasQtyGreatedThanStockOnHand: "Някои артикули имат количество, по-голямо от наличността. Моля, проверете отново!",
    rejectHeader: "Отхвърли {f}",
    rejectAlready: "Тези артикули вече са отхвърлени:<br/>{f}",
    reject: "Сигурни ли сте, че искате да отхвърлите {f}?<br/>Този процес не може да бъде отменен.",
    splitHeader: "Раздели {f}",
    splitSuccess: "Артикулът е разделен успешно!",
    splitFailed: "Грешка, не може да се раздели елементът.<br/>{f}",
    splitMultipleFailed: "Грешка, не може да се раздели повече от един елемент.",
    setVendorSuccess: "{f} е актуализиран успешно!",
    cancelReceipt: "Сигурни ли сте, че искате да отмените разписка {f}? Този процес не може да бъде отменен.",
    cancelReceiptSuccess: "{f} беше успешно отменен!",
    cancelReceiptFailed: "Грешка, не може да се отмени {f}.",
    cancelReceiptHeader: "Отказ на разписка {f}",
    undoReceipt: "Сигурни ли сте, че искате да отмените разписка {f}? Този процес не може да бъде отменен.",
    undoReceiptSuccess: "Отмяна на {f} успешно!",
    undoReceiptFailed: "Грешка, не може да се отмени {f}.",
    undoReceiptHeader: "Отмяна на разписка {f}",
    forceCloseHeader: "Принудително затваряне {f}",
    forceClose: "Сигурни ли сте, че искате да затворите насилствено {f1} реда от {f2}? Този процес не може да бъде отменен.",
    addfromReceiptSuccess: "{f} е добавен успешно, намерено е {d} дублиране",
    incompleteSearch: "{f} нуждае се от местоположение или филтър за артикул",
    postedFailedNoItems: "Грешка, не може да се публикува {f}. Трябва да имате поне 1 елемент за получаване.",
    postFailedNoItems: "Грешка, не може да се публикува {f}. Трябва да има поне 1 елемент в документа.",
    updateFailedOnUnitEmpty: "Грешка, не може да се запази {f1}.<br/>Тези артикул(и) нямат единица за измерване:<br/>{f2}",
    printFailedNoActiveFlow: "Грешка, не може да се отпечата този документ.<br/>Няма активен поток на документи, конфигуриран за партида {f}.",
    deleteFailedAlreadyReleased: "Грешка, не може да се изтрие {f}.<br/>Този документ вече е освободен.",
    processToPoFailedOnVendorEmpty: "Не може да продължите с поръчката. Моля, попълнете напълно заявката за покупка.",
    invalidAmount: "Грешка, невалидна сума за прилагане на записи",
    postedFailedNoItemsOnTable: "Грешка, не може да се публикува партида {f}. Трябва да има поне 1 документ на масата.",
    postBatchCompleted: "Партидата е завършена!",
    failedDocumentToPost: "Някой документ не успя да бъде публикуван:<br/>{f}",
    deleteAllSelected: "Сигурни ли сте, че искате да изтриете всички избрани елементи? Този процес не може да бъде отменен.",
    deleteFailedNoItemsSelected: "Грешка, не може да се изтрие {f}. Трябва да имате поне 1 избран елемент в таблицата.",
    deleteFailedNoItems: "Грешка, не може да се изтрие {f}. Трябва да има поне 1 елемент на масата.",
    setVendorFailedNoItemsSelected: "Грешка, не може да се зададе доставчик. Трябва да имате поне 1 избран елемент в таблицата.",
    deleteFailedForStatus: "Грешка, не може да се изтрие {f1}. {f2} вече {f3}.",
    deleteItemFailedForStatus: "Грешка, не може да се изтрият елементи. Статусът на елемента вече е променен.",
    processedItemsStatus: "- {f1} ({f2}) {f3} {f4} => <b>{f5}</b>",
    reopenFailedProcessedAlready: "Някои от елементите са обработени. Не може да се отвори отново!",
    postBatchConfirm: "Сигурни ли сте, че искате да публикувате всички данни в таблицата?",
    postSelectedConfirm: "Сигурни ли сте, че искате да публикувате избрания документ?",
    noItemSelected: "Грешка, няма избран елемент",
    postSRFailedPostingDateLessThanDocumentDate: "Грешка, не може да се публикува {f}. Датата на публикуване не може да е преди датата на документа.",
    setAllQtyToZero: "Сигурни ли сте, че искате да зададете количеството на нула? Този процес не може да бъде отменен.",
    updateLocationHeader: "Обнови местоположение на артикул",
    updateLocation: "Искате ли да актуализирате всички местоположения в реда в {f}?<br/>Този процес не може да бъде отменен.",
    setLocationSuccess: "Местоположението на артикула е актуализирано успешно!",
    allQtyToZeroSuccess: "Всичките количества са зададени на нула успешно!",
    allQtyToZeroFailed: "Грешка, не може да се зададе количеството на нула!",
    refreshPhysInvUnitCost: "Сигурни ли сте, че искате да обновите всички разходи за единица? Този процес не може да бъде отменен.",
    refreshPhysInvUnitCostSuccess: "Всички разходи за единица са актуализирани успешно!",
    refreshPhysInvUnitCostFailed: "Грешка, не може да обнови цената на единицата!",
    itemMassRecalculate: "Сигурни ли сте, че искате да преизчислите цената на единица за всички избрани артикули? Този процес не може да бъде отменен.",
    storeRequisitionRefreshUnitCost: "Сигурни ли сте, че искате да преизчислите всички артикули и да обновите цената на единица за всички редове в този документ? Този процес не може да бъде отменен.",
    revertPostedStoreRequisition: "Сигурни ли сте, че искате да върнете тази подадена заявка за магазин? Този процес ще премахне всички записи, свързани с този документ, и ще върне SR в статус \"освободен\". Този процес не може да бъде отменен.",
    revertPostedStoreRequisitionSuccess: "Публикуваната заявка за магазин е върната успешно!",
    revertPostedStoreRequisitionFailed: "Грешка, не може да се върне публикуваната заявка за магазин!",
    deleteItemLedgerEntry: "Сигурни ли сте, че искате да изтриете записа на този елемент? Този процес ще премахне всички записи, свързани с този документ. Този процес не може да бъде отменен.",
    deleteItemLedgerEntrySuccess: "Записът за артикула е изтрит успешно!",
    deleteItemLedgerEntryFailed: "Грешка, не може да се изтрие записът!",
    deleteItemLedgerEntryTypeNotAllowed: "Този тип запис не може да бъде изтрит.",
    itemMassRecalculateSuccess: "Всички разходи за единица са преизчислени!",
    itemMassRecalculateFailed: "Грешка, неуспешно преизчисляване на разходите за единица!",
    itemMassRecalculateNoData: "Пресмятането на артикула не е извършено, няма намерени данни!",
    refreshUnitCostSuccess: "Всички разходи за единица са обновени!",
    refreshUnitCostFailed: "Грешка, не може да се обнови цената на единицата!",
    itemTypeIsNotGl: "Типът на елемента не е разрешен",
    withdrawHeader: "Изтегли {f}",
    withdraw: "Сигурни ли сте, че искате да изтеглите {f}? Този процес не може да бъде отменен.",
    withdrawSuccess: "{f} е успешно изтеглен!",
    delegateSuccess: "{f} е делегиран успешно!",
    delegate: "Сигурни ли сте, че искате да делегирате <strong>{t}</strong> от името на <strong>{f}</strong>? Уведомени ще бъдат засегнатите потребители.",
    delegateHeader: "Делегирай {t}",
    viewReportFailedNoSetup: "Не може да се види отчет поради липсваща информация в настройките за съгласуване на инвентара.<br/>Моля, първо завършете всички настройки!",
    approvalSubmissionSuccess: "{f} беше успешно изпратено за одобрение!",
    closeIncomeStatementSuccess: "Записите в дневника за закриване на отчета за приходи са успешно създадени. Моля, вижте създадените дневници в указаната партида.",
    closeIncomeStatementFailed: "Грешка, неуспешно създаване на журнал за приходите",
    entryEditorSuccess: "Записът е актуализиран успешно!",
    removeApplyToJournalIdAndAmountToApplyWithId: "Премахване на приложен журнал с ID: {f}",
    removeApplyToJournalIdAndAmountToApplyFailed: "Грешка, не може да се премахне {f}. Идентификаторът на дневника все още съществува.",
    removeApplyToJournalIdAndAmountToApplyErrorFailed: "Грешка, неуспешно премахване на приложен журнал",
    removeApplyToJournalIdAndAmountToApplyErrorCheckJournal: "Грешка, не може да се премахне поради грешка в проверката на журнала",
    removeApplyToJournalIAndAmountToApplydNotAllowed: "Премахването на приложен журнал не е разрешено",
    submitSuccess: "{f} е изпратено успешно!",
    withdrawDocument: "Сигурни ли сте, че искате да изтеглите документа? Този процес не може да бъде отменен.",
    adjustAllConfirmation: "Сигурни ли сте, че искате да коригирате всички елементи?<br/>Този процес не може да бъде отменен.",
    adjustConfirmation: "Сигурни ли сте, че искате да направите корекции само на филтрираните елементи?<br/>Този процес не може да бъде отменен.",
    viewReportFailedNoAccountSetup: "Не може да се види отчет. Трябва да имате поне 1 акаунт в настройките!",
    defaultDirectExpenseChanged: "Стандартният директен разход е променен",
    overwriteDirectExpenseLineConfirm: "Искате ли да презапишете всички редове с новия по подразбиране?",
    existingLineRemovalConfirm: "Съществуващата линия ще бъде премахната. Сигурни ли сте?",
    undoForceCloseHeader: "Отмяна на принудително затваряне {f}",
    undoForceClose: "Сигурни ли сте, че искате да отмените принудителното затваряне на този елемент?",
    undoForceCloseFailed: "Не може да се отмени, някои елементи все още не са затворени!",
    errorEmptyLines: "Редовете не могат да бъдат празни",
    failedGetSOHForItem: "Грешка, не може да се получи наличност за този артикул.",
    invalidThresholdItems: "- {f1} ({f2}), цена на единица {f3} с последна директна цена {f4}",
    filteringWillBeReleased: "Всички условия за филтриране ще бъдат премахнати, следователно всички елементи ще бъдат обработени. Сигурни ли сте?",
    areYouSure: "Сигурни ли сте?",
    setToCompletelyReceivedConfirmation: "Сигурни ли сте, че искате да зададете това като напълно получено?",
    unsetCompletelyReceivedConfirmation: "Сигурни ли сте, че искате да отмените получаването напълно?",
    confirmAction: "Потвърдете действието",
    areYouSureToAction: "Сигурни ли сте, че искате да {action}?",
    costsUpdated: "Цените на артикулите бяха актуализирани успешно!",
    costsUpdateFailed: "Грешка, не може да се актуализират разходите за артикула.",
    incorrectCostsWarning: "Следните артикули имат единични разходи, които се различават от разходите за наличност. Можете да отмените или автоматично да актуализирате всички единични разходи.",
    incorrectCostsTitle: "Артикули с неправилни разходи",
    incorrectCostsContinueAnyway: "Продължи все пак",
    incorrectCostsUpdate: "Обнови цена на единица",
    incorrectCostsItemCode: "Код на артикула",
    incorrectCostsLocation: "Местоположение",
    incorrectCostsCurrentUnitCost: "Текуща цена на единица",
    incorrectCostsStockOnHandCost: "Стойност на наличност",
    incorrectCostsDifference: "Разлика",
    incorrectCostsStockOnHand: "Наличност",
    confirmDelete: "Сигурни ли сте, че искате да изтриете този {f}?",
    confirmDeleteMultiple: "Сигурни ли сте, че искате да изтриете тези {f}?",
    setVatFailedNoItemsSelected: "Грешка, не може да се зададе ДДС. Трябва да има поне 1 избран елемент в таблицата.",
    confirmUpdate: "Сигурни ли сте, че искате да актуализирате този {f}?",
    postSelectedConfirmWithCount: "Сигурни ли сте, че искате да публикувате {v} избрани документа?",
    confirmSendEmail: "Сигурни ли сте, че искате да изпратите имейли до избраните фактури?",
    updatePurchaseOrderStatusConfirmation: "Сигурни ли сте, че искате да промените статуса от '{f1}' на '{f2}'?",
    updatePurchaseOrderStatusConfirmationWithDoc: "Сигурни ли сте, че искате да промените статуса на поръчка '{f1}' от '{f2}' на '{f3}'?",
    updateUnitCostVendorComparisonLowestSuccess: "{f} е актуализиран с най-ниската цена чрез сравнение на доставчици!",
    updateUnitCostVendorComparisonLowestFailed: "Грешка, не може да се актуализира цената на единицата с цената на доставчика (най-ниска).",
    successRecalculateInventory: "Физическият инвентарен журнал е преразчетен!",
    failedRecalculateInventory: "Грешка, не може да се преизчисли Журналът за физическа инвентаризация.",
    revertSuccess: "{f} беше успешно възстановен!",
    revertFailed: "Грешка, не може да се върне {f}.",
    dimensionBulkImportSuccess: "{dimensions} размери добавени, {values} стойности добавени",
    coaDimensionBulkImportSuccess: "{mappings} мапинга добавени, {rules} правила добавени",
    updateCoaDimensionMappingConfirmation: "Сигурни ли сте, че искате да актуализирате това картографиране?",
    downloadFailedActiveFlowIsEmpty: "Грешка, не може да се изтегли този документ.<br/>Текущият активен документен поток не е конфигуриран или е все още празен.",
    calculateInventoryFilterWarning: "При използване на филтъра по-долу, изчислението на инвентара ще създаде нов запис вместо да презапише съществуващия.",
    processExpiredWarning: "Сигурни ли сте, че искате да изтече старите записи? Записите по-стари от {x} ще бъдат маркирани като изтекли. Това действие може да бъде отменено, но само ръчно за всеки запис.",
    forceCloseWarning: "Сигурни ли сте, че искате да затворите стари записи? Всички записи по-стари от {x} ще бъдат трайно затворени. Това действие не може да бъде отменено.",
    revertExpiredWarning: "Сигурни ли сте, че искате да възстановите изтеклите записи?",
    addfromReceiptRejected: "{f} реда отхвърлени: {m}",
    postPositiveAdjustmentNotAllowed: "Не може да се публикува: положителна корекция не е разрешена за {f}.",
    postAllBatchHeader: "Публикувай всички {f} партиди",
    deleteAllBatchHeader: "Изтрий всички {f} партиди",
    deleteAllBatch: "Сигурни ли сте, че искате да изтриете всички {f1} редове на дневника в {f2} {f3} партиди? <br> Този процес не може да бъде отменен.",
    postAllBatch: "Сигурни ли сте, че искате да публикувате {f1} партиди от {f2}? Всяка партида се проверява преди публикуване; партидите, които не преминат, се пропускат.<br> Този процес не може да бъде отменен.",
    inputQuantityMustBeGreaterThanZero: "Количество трябва да е по-голямо от нула.",
  },
  data: {
    clientLedgerEntryId: "ID на запис в клиентската книга",
    vendorLedgerEntryId: "ID на запис в книгата на доставчика",
    isReconciled: "Съгласувано ли е?",
    isCloseYearEntry: "Запис за затваряне на година ли е?",
    stockOnHand: "Наличност на склад",
    inputStockOnHand: "Въведи наличност на склад",
    inputStockOnHandFrom: "Въведи наличност на склад (от)",
    inputStockOnHandTo: "Въведи наличност на склад (до)",
    stockOnHandFrom: "Наличност на склад (от)",
    stockOnHandTo: "Наличност на склад (до)",
    reconciliationGlAccount: "GL сметка за съгласуване",
    virtualAccount: "Виртуална сметка",
    accountName: "Име на сметка",
    accountNameList: "Списък с имена на сметки",
    accountNumber: "Номер на сметка",
    bankAccountPostingGroupCode: "Код на група за осчетоводяване на банкови сметки",
    bankAccountPostingGroupName: "Име на група за осчетоводяване на банкови сметки",
    reconciliationAccount: "Сметка за съгласуване",
    reconciliationBankAccount: "Банкова сметка за съгласуване",
    isReconciliationAccount: "Сметка за съгласуване ли е?",
    showOppositeSigninReport: "Показвай обратен знак в отчета",
    setWidenedPhysicalInventoryRow: "Задай разширен ред за физически инвентар",
    itemVendorPurchaseprice: "Покупна цена на артикул от доставчик",
    startDate: "Начална дата",
    endDate: "Крайна дата",
    startDateWithPlaceholderDDMMYYYY: "Начална дата (ДД-ММ-ГГГГ)",
    endDateWithPlaceholderDDMMYYYY: "Крайна дата (ДД-ММ-ГГГГ)",
    purchasePrice: "Покупна цена",
    year: "Година",
    lastIleId: "Последен ILE ID",
    inventoryPostingType: "Тип осчетоводяване на склад",
    isFlashCostStoreRequisition: "Флаш разход за заявка от магазин ли е?",
    isFlashCostPurchaseRequisition: "Флаш разход за заявка за покупка ли е?",
    requestStatus: "Статус на заявка",
    receiptStatus: "Статус на получаване",
    created: "Създадено",
    createdBy: "Създадено от",
    createdAt: "Създадено на",
    lastModified: "Последна промяна",
    lastModifiedBy: "Променено от",
    swiftCode: "SWIFT код",
    defaultBank: "Стандартна банка",
    destinationName: "Име на дестинация",
    destinationID: "ID на дестинация",
    department: "Отдел",
    clientInfo: "Информация за клиент",
    clientCode: "Код на клиент",
    clientName: "Име на клиент",
    clientId: "ID на клиент",
    guestName: "Име на гост",
    appliedVendorLedgerEntryId: "ID на приложен запис в книгата на доставчика",
    appliedClientLedgerEntryId: "ID на приложен запис в клиентската книга",
    appliedBankAccountLedgerEntryId: "ID на приложен запис в банковата книга",
    defaultGuestInhouseAccountId: "Стандартен вътрешен акаунт на гост",
    isReceivedCompletely: "Получено напълно",
    termCode: "Код на условие",
    termName: "Име на условие",
    searchBar: "Търси нещо тук...",
    netChange: "Нетна промяна",
    entry: "Запис",
    totalDocument: "Общ брой документи",
    vendorCode: "Код на доставчик",
    vendorName: "Име на доставчик",
    itemCode: "Код на артикул",
    itemName: "Име на артикул",
    itemID: "ID на артикул",
    itemTypeName: "Име на тип артикул",
    itemTypeID: "ID на тип артикул",
    itemDescription: "Описание на артикул",
    itemUnitCost: "Единична цена на артикул",
    vatAmount: "Сума на ДДС",
    autoRecalculateCost: "Автоматично преизчисляване на цена",
    step: "Стъпка",
    allowMultiple: "Позволи множество",
    posting: "Осчетоводяване",
    invoice: "Фактура",
    receipt: "Разписка",
    receiptPosting: "Осчетоводяване на разписка",
    order: "Поръчка",
    wording: "Формулировка",
    defaultName: "Стандартно име",
    defaultRoleName: "Стандартно име на роля",
    role: "Роля",
    defaultVatProductPostingGroup: "Стандартна група за осчетоводяване на ДДС продукти",
    conversion: "Конверсия",
    email: "Имейл",
    accountNo: "Номер на сметка",
    glAccount: "GL сметка",
    location: "Местоположение",
    offsetLocation: "Офсет местоположение",
    defaultFromLocation: "Стандартно изходно местоположение",
    defaultToLocation: "Стандартно входящо местоположение",
    invPostGroup: "Група за осчетоводяване на склад",
    accountCode: "Код на сметка",
    interimAccountName: "Име на временна сметка",
    interimAccountNo: "Номер на временна сметка",
    purchaseAccount: "Сметка за покупки",
    accrualInterimAccount: "Временна начислителна сметка",
    inventoryAdjustmentAccount: "Сметка за корекция на склад",
    expenseInventoryAdjustmentAccount: "Сметка за разходи по корекция на склад",
    directCostAppliedAccount: "Сметка за приложени директни разходи",
    vatBusPostGroup: "Група за осчетоводяване на ДДС бизнес",
    vatBusPostGroupCode: "Код на група за осчетоводяване на ДДС бизнес",
    vatBusPostGroupID: "ID на група за осчетоводяване на ДДС бизнес",
    vatProductPostingGroup: "Група за осчетоводяване на ДДС продукти",
    vatProductPostingGroupID: "ID на група за осчетоводяване на ДДС продукти",
    whtVatProductPostingGroup: "Група за осчетоводяване на удържан ДДС",
    genBusPostGroup: "Група за осчетоводяване на общ бизнес",
    genBusPostGroupCode: "Код на група за осчетоводяване на общ бизнес",
    genBusPostGroupID: "ID на група за осчетоводяване на общ бизнес",
    genProdPostGroup: "Група за осчетоводяване на общи продукти",
    genProdPostGroupID: "ID на група за осчетоводяване на общи продукти",
    bankAccPostGroup: "Група за осчетоводяване на банкови сметки",
    documentType: "Тип документ",
    documentNo: "Номер на документ",
    batch: "Партида",
    description: "Описание",
    postingDate: "Дата на осчетоводяване",
    expectedDate: "Очаквана дата",
    paymentTerm: "Условия за плащане",
    directExpenseGenBusPostGroup: "Група за осчетоводяване на директни разходи (бизнес)",
    directExpenseGenProdPostGroup: "Група за осчетоводяване на директни разходи (продукт)",
    directExpenseAdjustmentAccount: "Сметка за корекция на директни разходи",
    defaultDirectExpenseGenBusPostGroup: "Стандартна група за директни разходи (бизнес)",
    custPostGroup: "Клиентска група за осчетоводяване",
    vendorPostGroup: "Група за осчетоводяване на доставчици",
    journalTemplate: "Шаблон на журнал",
    journalTemplateId: "ID на шаблон на журнал",
    journalBatchId: "ID на партида на журнал",
    revenueLineId: "Идентификатор на реда за приходи",
    noSeries: "Серия номера",
    defaultLocation: "Стандартно местоположение",
    prefix: "Префикс",
    startingNumber: "Начален номер",
    endingNumber: "Краен номер",
    lastNumberUsed: "Последен използван номер",
    lengthOfNumber: "Дължина на номера",
    includeYear: "Включи година",
    includeMonth: "Включи месец",
    includeDate: "Включи дата",
    isEditable: "Може да се редактира",
    branch: "Клон",
    bankAccountNo: "Номер на банкова сметка",
    virtualAccountNo: "Номер на виртуална сметка",
    allowPostingFrom: "Позволи осчетоводяване от",
    allowPostingTo: "Позволи осчетоводяване до",
    receivableAccount: "Сметка вземания",
    receivableAccountNo: "Номер на сметка вземания",
    payableAccount: "Сметка задължения",
    balanceAccount: "Сметка баланс",
    accountCategory: "Категория на сметка",
    accountType: "Тип сметка",
    directPost: "Директно осчетоводяване",
    blocked: "Блокирано",
    vatPercentage: "ДДС процент",
    startingDate: "Начална дата",
    closed: "Затворено",
    endingDate: "Крайна дата",
    dueDateCalc: "Изчисляване на падежна дата",
    debitAmount: "Сума дебит",
    creditAmount: "Сума кредит",
    amount: "Сума",
    isApplied: "Приложено ли е",
    appliedSalesInvoiceId: "ID на приложена фактура за продажба",
    appliedSalesCreditMemoId: "ID на приложена кредитно известие за продажба",
    cashDeskMovementId: "ID на движение в каса",
    isDirectExpense: "Директен разход",
    id: "ID",
    remarkInternalNoteForPurchasingOnly: "Забележка (вътрешна бележка само за покупки)",
    minUnitCost: "Минимална единична цена (%)",
    maxUnitCost: "Максимална единична цена (%)",
    unitCost: "Единична цена",
    lastDirectCost: "Последна директна цена",
    reorderQuantity: "Количество за презареждане",
    code: "Код",
    name: "Име",
    balance: "Салдо",
    address: "Адрес",
    city: "Град",
    country: "Държава",
    contactName: "Име за контакт",
    phoneNo: "Телефонен номер",
    vendorPostingGroup: "Група за осчетоводяване на доставчици",
    costingMethod: "Метод на калкулация",
    no: "Не",
    glAccountNo: "Счетоводен номер",
    unit: "Единица",
    baseUnitCost: "Цена на базовия модул",
    inputUnitCost: "Входна единична цена",
    totalling: "Общо",
    totallingFrom: "Общо от",
    totallingTo: "Общо до",
    directPosting: "Директно публикуване",
    batchName: "Име на партида",
    lineNo: "Номер на реда",
    inventory: "Инвентаризация",
    vendorAccount: "Профил на доставчик",
    clientAccount: "Клиентски акаунт",
    totalAmount: "Обща сума",
    selectedTotalAmount: "Обща избрана сума",
    status: "Статус",
    purchasingStatus: "Статус на покупката",
    quantity: "Количество",
    value: "Стойност",
    inputQuantity: "Въведете количество",
    inputUom: "Входна мерна единица",
    forceCloseReason: "Причина за принудително затваряне",
    unitPrice: "Цена на единица",
    totalPrice: "Обща цена",
    closedByUser: "Затворено от потребител",
    includeAutoClosed: "Включи автоматично затворени",
    baseQuantity: "Основно количество",
    orderDate: "Дата на поръчка",
    amountIncVat: "Сума с ДДС",
    amountExcVat: "Сума без ДДС",
    unitCostIncVat: "Цена на единица с ДДС",
    itemNo: "Артикул №",
    purchaseRequestNo: "Номер на PR",
    purchaseOrderNo: "Номер на поръчка",
    deliveryDate: "Дата на доставка",
    quantityOutstanding: "Неплатено количество",
    type: "Тип",
    balanceToDate: "Баланс до момента",
    subTotal: "Междинна сума",
    vat: "ДДС",
    totalIncVat: "Общо с ДДС",
    vendorDeliveryNo: "Номер на доставка от доставчик",
    poNo: "Номер на поръчка",
    salesTaxAccount: "Сметка за продажен данък",
    purchaseTaxAccount: "Сметка за данък върху покупките",
    total: "Общо",
    totalRows: "Общо редове:",
    purchaseRequestSeries: "Серия на искания за покупка",
    purchaseOrderSeries: "Серия на поръчките",
    purchaseReceiptSeries: "Серия на разписка за покупка",
    purchaseInvoiceSeries: "Серия на фактури за покупка",
    purchaseInvoiceLabel: "Етикет на фактура за покупка",
    purchaseReceiptLabel: "Етикет за покупка",
    purchaseCreditMemoSeries: "Закупуване на кредитна серия",
    salesInvoiceSeries: "Серия фактури",
    salesCreditMemoSeries: "Серия продажби",
    receivableInvoiceSeries: "Серия на фактури за вземане",
    symbol: "Символ",
    transferOrderSeries: "Серия на поръчка за пренос",
    defaultCostingMethod: "Метод за ценообразуване по подразбиране",
    quantityReceived: "Получено количество",
    quantityInvoiced: "Фактурирано количество",
    quantityPO: "Количество поръчано",
    quantityToReceive: "Количество за получаване",
    quantityOrdered: "Поръчано количество",
    purchaseReceivingList: "История на разписките за покупки",
    quantityToInvoice: "Количество за фактуриране",
    prNumber: "Номер на заявка за покупка",
    vendorOneName: "Доставчик 1",
    vendorOnePrice: "Цена 1",
    vendorTwoName: "Доставчик 2",
    vendorTwoPrice: "Цена 2",
    vendorThreeName: "Доставчик 3",
    vendorThreePrice: "Цена 3",
    showVendorColumns: "Покажи колона за сравнение на доставчици",
    showVendorDetail: "Покажи доставчик",
    showSOHByInputUOM: "Покажи наличност по входна единица за измерване",
    showByInputUOM: "Покажи по входна единица",
    expirationDate: "Срок на годност",
    vendorInvoiceNo: "Номер на фактура на доставчика",
    receiptNo: "Номер на разписка",
    invoiceNo: "Фактура №",
    sourcePurchaseInvoice: "Изходна фактура за покупка",
    targetPurchaseInvoice: "Целева фактура за покупка",
    movePreview: "Преглед на преместването",
    from: "От",
    to: "Към",
    dueDate: "Срок",
    documentFlow: "Активен документен поток",
    receivableInvoiceDocumentFlow: "Активен документен поток на фактура за вземане",
    quantityToBeReceive: "Остава за получаване",
    detail: "Детайл",
    purchaseRequisitionTemplate: "Шаблон за заявка за покупка",
    entryType: "Тип запис",
    invoicedQuantity: "Фактурирано количество",
    ileQuantity: "Количество ILE",
    ileBaseQuantity: "Основно количество ILE",
    remainingQuantity: "Оставащо количество",
    remainingQuantityToInvoice: "Оставащо за фактуриране",
    outboundIle: "Изходящ ILE",
    inboundIle: "Входящ ILE",
    costAmountExpected: "Очаквана сума",
    costAmountActual: "Действителна сума",
    valuationDate: "Дата на оценка",
    averageCostEntryType: "Тип за въвеждане на средна цена",
    glRegisterId: "Ид на GL регистрация",
    sourceDocumentNo: "№ на изходен документ",
    sourceIdtDocumentNo: "№ на изходен IDT документ",
    reconciledGlRegisterId: "Съгласувано по GL Регистър ID",
    isAdjustment: "Настройка",
    valuedQuantity: "Ценено количество",
    applyToEntry: "Кандидатствай за вход №",
    fixedApply: "Фиксирано Приложение",
    removeApplyToJournalIdAndAmountToApply: "Премахни приложен журнал",
    applyToJournalIdAndAmountToApply: "Приложи към Идентификатор на списание и сума за приложение",
    applyToJournalId: "Кандидатствай за ИД на списание",
    amountToApply: "Сума за прилагане",
    applied: "Приложено",
    invoiceDate: "Дата на фактурата",
    remainingAmount: "Оставаща сума",
    remainingAmountIncVat: "Оставаща сума с ДДС",
    unapplied: "Не приложен",
    unappliedById: "Не приложено по ID",
    currencyCode: "Валутен код",
    reversed: "Обратен",
    reversedBy: "Обратено от",
    open: "Отвори",
    vendorInfo: "Информация за доставчика",
    itemNotOnInventory: "Артикулът не е в наличност",
    dateFilterStart: "Начална дата",
    dateFilterEnd: "Крайна дата",
    dateFilter: "Филтър по дата",
    locationFilter: "Филтър по местоположение",
    batchFilter: "Филтър на партиди",
    itemFilter: "Филтър на елементи",
    quantityPhysicalInventory: "Количество (Физически инвентар)",
    quantityCalculated: "Количество (Изчислено)",
    documentDate: "Дата на документа",
    requestByUser: "Изисквано от",
    fromLocation: "От",
    toLocation: "До",
    postingUser: "Публикувано от",
    posted: "Публикувано",
    isPosted: "Публикувано",
    quantityShipped: "Изпратено количество",
    baseQuantityShipped: "Основно количество за доставка",
    locationCode: "Код на местоположение",
    locationName: "Име на местоположение",
    chartOfAccountDetail: "Детайли на сметката",
    taxType: "Тип данък",
    notAvailable: "Недостъпно",
    notApplicable: "Не е приложимо",
    appliesToPostedSalesInvoiceId: "Идентификатор на приложена фактура за продажба",
    appliesToPostedPurchaseInvoiceId: "Идентификатор на приложена фактура за покупка",
    appliesToPostedSalesCreditMemoId: "Приложен кредитен меморандум за продажби",
    isForceClosed: "Затворено с сила",
    monthClosed: "Затворен месец",
    yearClosed: "Година затворена",
    inventoryClosed: "Инвентаризацията е затворена",
    createYear: "Настройка за година",
    includeIncome: "Включи затваряща записка",
    retainedEarningAccount: "Счетоводен акаунт на задържани печалби",
    closeIncomeStatementJournalBatch: "Затвори партида на отчета за приходи",
    witholdingTaxDefaultJournalBatch: "Партида по подразбиране за данък удръжка",
    showQuantityCalculated: "Покажи колона Количество (Изчислено)",
    showQuantityAdjusted: "Покажи колона Количество (Коригирано)",
    showAgedColumn: "Покажи колона Възраст",
    showAgingDays: "Покажи дни на стареене",
    coaApInterim: "Временен COA AP",
    originalQuantity: "Оригинално количество",
    splitQuantity: "Количество за разделяне",
    appliesToInvoiceNo: "Отнася се за публикувана фактура за покупка",
    appliesToSalesInvoiceNo: "Отнася се за публикувана фактура за продажба",
    vendorId: "Идентификатор на доставчика",
    itemJournalMasterTemplate: "Шаблон на главния журнал на артикули",
    generalJournalMasterTemplate: "Основен шаблон на общия журнал",
    checkIn: "Чек-ин",
    checkOut: "Плащане",
    night: "нощ",
    roomNo: "Стая №",
    receivableInvoiceFooter: "Футер на фактура за вземания",
    receivableInvoiceHeader: "Заглавие на фактура за вземане",
    allowBiggerQuantityInPurchaseOrder: "Позволи по-голямо количество в поръчката",
    defaultPrintPOGroupLocation: "По подразбиране групирано по местоположение при печат на поръчка за покупка",
    footerAutoColumn: "Автоматичен колона в долния край",
    allowAddNewItemInPOFromPR: "Позволи добавяне на нов артикул в ПО от ЗП",
    allowFlexibleItemInPO: "Позволете гъвкавост в артикул на ПО (ръчно и артикул на ПР)",
    allowChangePriceWhenPOIsReleased: "Позволи промяна на цената при освобождаване на поръчката",
    useCompanyNameForPrintout: "Използвайте юридическото име на компанията в заглавието на разпечатката",
    useBrandHotelNameForPrintout: "Използвайте името на хотела в заглавието на разпечатката",
    purchaseOrderFooter: "Футер на поръчка",
    customFooterPurchaseOrderText: "Персонализиран текст за долния колонтитул на поръчката за покупка",
    customFooterPurchaseRequestText: "Персонализиран текст за долния колонтитул на заявката за покупка",
    customFooterPurchaseInvoiceText: "Персонализиран текст за долния колонтитул на фактурата за покупка",
    customFooterPurchaseReceiptText: "Персонализиран текст за долния колонтитул на разписката за покупка",
    customFooterStoreRequisitionText: "Персонализиран текст за долния колонтитул на заявката за магазин",
    lastPrice: "Последна цена",
    baseLastPrice: "Основна последна цена",
    defaultFOCashDesk: "Стандартно FO Касово бюро",
    defaultFOCollectionType: "Тип по подразбиране на FO колекция",
    documentTitle: "Заглавие на документа",
    startPostingDate: "Начална дата на публикацията",
    endPostingDate: "Дата на приключване на публикуване",
    allVendors: "Всички доставчици",
    allGroups: "Всички групи",
    inventoryGroup: "Група инвентар",
    noteCurrency: "Забележка: Валутата, използвана в този отчет, е {f}",
    otaBookingId: "ИД за резервация OTA",
    otaBookingClientPostingGroup: "Група за публикуване на клиенти за показване на OTA ID за резервация",
    show: "Покажи",
    all: "Всички",
    fromAccount: "От акаунт",
    toAccount: "Към акаунта",
    noteAccountFromTo: "Забележка: Този отчет ще бъде филтриран от акаунт <strong>{f1}</strong> до <strong>{f2}</strong>",
    showDetail: "Покажи детайли",
    showAllAccounts: "Покажи всички акаунти",
    agedAsOfThisDate: "Възраст към тази дата",
    grandTotal: "Обща сума",
    receivableNo: "Номер на вземане",
    showAllClients: "Покажи всички клиенти",
    copiedToClipboard: "Копирано в клипборда!",
    sortOrder: "Подредба",
    setAppliesTo: "Настройката важи за: {f}",
    date: "Дата",
    hotelName: "Име на хотела",
    source: "Източник",
    days130: "1-30 дни",
    days3160: "31-60 дни",
    days6190: "61-90 дни",
    days91120: "91-120 дни",
    days120: ">120 дни",
    periodLabel: "{d1} до {d2}",
    downloadGSheet: "Изтегли GSheet",
    downloadExcel: "Изтегли Excel",
    downloadPDF: "Изтегли PDF",
    report: "Доклад",
    period: "Период",
    group: "Група",
    totalCost: "Обща цена",
    totalCostAdjust: "Обща корекция на разходите",
    totalAdjustment: "Обща корекция",
    lineStatus: "Статус на линията",
    useSystematicApproval: "Използвай системно одобрение",
    setDefaultDirectExpense: "Задай по подразбиране пряка разход",
    itemType: "Тип артикул",
    article: "Артикул за продажба",
    articleType: "Тип артикул за продажба",
    baseSellingPrice: "Базова продажна цена",
    costPercentage: "Разход %",
    headerNoSeries: "Серия номера на заглавие",
    lineNoSeries: "Серия номера на ред",
    lineDocumentNo: "Номер на документ на ред",
    outlet: "Обект",
    notesOrReason: "Бележки / Причина",
    user: "Потребител",
    approved: "Одобрено",
    rejected: "Отхвърлено",
    declined: "Отказано",
    preparedBy: "Подготвено от",
    checkedBy: "Проверено от",
    approvedBy: "Одобрено от",
    approverName: "Име на одобряващия",
    sequence: "Последователност",
    flowOrder: "Поръчка на потока",
    priority: "Приоритет",
    defaultPurchaseRequestPriority: "Приоритет на стандартната заявка за покупка",
    defaultDirectExpenseItemJournalBatch: "Журнална партида за директни разходи по подразбиране",
    earliest: "Най-рано",
    latest: "Най-ново",
    showSummary: "Покажи резюме",
    delegatedTo: "Делегирано на",
    footerText: "Текст в долния колонтитул",
    formattingNotes: "Тези форматиращи тагове могат да се прилагат само на всеки ред: *удебелен* _курсив_",
    showHotelLogo: "Покажи логото на хотела",
    showHotelAddress: "Покажи адреса на хотела",
    food: "Храна",
    beverage: "Напитка",
    material: "Материал",
    engineering: "Инженерство",
    showEngineering: "Покажи инженерния акаунт в отделен таб",
    coaID: "ИД на COA",
    addAccount: "Добави акаунт",
    selectAccountName: "Изберете име на акаунт",
    selectDimensionValue: "Изберете стойност на измерение",
    restore: "Възстанови",
    setToNonDirectExpense: "Настройка на непреки разходи",
    includeApprovalNotes: "Включи бележки за одобрение",
    reviewedBy: "Прегледано от",
    reviewedAt: "Прегледано на",
    delegatedAt: "Делегирано на",
    delegatedFrom: "Делегирано от",
    isOpen: "Отворено",
    showAllItems: "Покажи всички елементи",
    hideUnopenedItems: "Скрий неизползвани елементи",
    summaryByLocation: "Резюме по локация",
    showAllBanks: "Покажи всички банки",
    splitVendorDescription: "Раздели описание на доставчика",
    creditAccount: "Кредитна сметка",
    debitAccount: "Дебитна сметка",
    totalCredit: "Общ кредит",
    totalDebit: "Общ дебит",
    totalLedger: "Обща книга",
    totalPayment: "Обща сума",
    summary: "Резюме",
    hideAmountInPurchaseRequestPrintout: "Скрий сумата в разпечатката на заявката за покупка",
    showTotalCostInPurchaseRequestPrintVendorComparison: "Покажи обща цена в заявка за покупка Сравнение на доставчици",
    enableDescriptionCopyToRemark: "Активиране на копиране на описание в забележка при заявка за покупка",
    allowSOHZeroWhenStoreRequisitionIsSaved: "Позволи SOH нула при запазване на заявка за магазин",
    allowRequestedQtyBiggerThanSoh: "Позволи заявеното количество да е по-голямо от наличността",
    useLastDirectCostWhenNoContract: "Използвай последната директна цена, когато няма намерена цена по договор",
    useLastDirectCostWhenNoContractNote: "При назначаване на доставчик в неплатена заявка за покупка и когато цената по договора не е налична, заменете потребителския вход с последната директна цена (Това важи и за поръчка за покупка)",
    itemCodeGeneratedBySystem: "Кодът на артикула ще бъде генериран от системата",
    mdrFee: "Диск. ставка на търговеца {f} (%)",
    batchHasMdrFee: "Партида <strong>{f}</strong> има опции за отстъпка на търговеца:",
    showZeroBalance: "Покажи нулев баланс",
    targetEntry: "Целеви запис",
    approvalPrintout: "Одобрение Принт",
    document: "Документ",
    outstanding: "Изключителен",
    documentsSelected: "избрани документи",
    documentSelected: "избран документ",
    defaultVendorSetup: "Стандартна настройка за доставчик",
    defaultClientSetup: "Стандартна настройка за клиент",
    defaultItemSetup: "Стандартна настройка за елемент",
    noVat: "Без ДДС",
    purchaseOrderDocumentFlow: "Документен поток на поръчка",
    dailyMarketListDocumentFlow: "Документален поток за ежедневен пазарен списък",
    remark: "Забележка",
    deleteRemark: "Изтрий бележка",
    taxIdentificationNumber: "Данъчен идентификационен номер",
    attachment: "Прикачен файл",
    fileFormat: "Формат на файла",
    adjustAllItems: "Настрой всички елементи",
    adjustFilteredItems: "Настройка на филтрирани елементи",
    adjustItem: "Настройка на елемент",
    showItemDetail: "Покажи артикул",
    showClientDetail: "Покажи клиент",
    showPurchaseBook: "Покажи книга за покупка",
    queryDate: "Дата на запитване",
    queryAdjustmentDate: "Дата на запитване и корекция",
    adjustmentPostingDate: "Дата на корекция",
    valueEntryID: "Идентификатор на записа",
    costAmountAdjustment: "Корекция на стойността",
    viewData: "Преглед на данни",
    ileID: "ИД на ILE",
    lastValueEntryID: "ID на последната стойност",
    unitCostThreshold: "Праг на единична цена",
    unitCostThresholdUsingLastDirectCost: "Праг на единичната цена с последната директна цена",
    isReversed: "Обратен",
    reversedPostingDate: "Обратна дата на публикуване",
    descriptionForVendor: "Описание (за доставчик)",
    remarkInternalOnly: "Забележка за покупка (само за вътрешна употреба)",
    isDML: "ДML е",
    inputUOMID: "Въведете ID на единица за измерване",
    inputUOMCode: "Въведете код на единица мярка",
    inputUOMName: "Въведете име на единица за измерване",
    transferOrder: "Поръчка за прехвърляне",
    negativeAdjustment: "Отрицателна корекция",
    quantityEqualZero: "Бр. = 0",
    quantityGreaterThanZero: "Брой > 0",
    costNegative: "Отрицателна стойност",
    groupByLocation: "Групиране по местоположение",
    groupByVendor: "Групиране по доставчик",
    showAllARCard: "Покажи всички A/R карти",
    setToCompletelyReceived: "Зададено на Пълно Получено",
    unsetCompletelyReceived: "Премахни напълно получено",
    defaultChartOfAccount: "Стандартна счетоводна сметка",
    defaultCOAAmount: "Стандартна сума на COA",
    defaultDescription: "Описание по подразбиране",
    salesInvoiceNumberSeries: "Серия на фактури за продажби",
    invoiceHeaderAddress: "Адрес на фактурата",
    openingInventory: "Отваряне на инвентар",
    incomingInventory: "Постъпващ инвентар",
    closingInventory: "Затваряне на инвентар",
    inventoryAvailable: "Наличен инвентар",
    grossConsumption: "Бруто потребление",
    creditsConsumption: "Кредити - Консумация",
    creditsComplimentaryCost: "Кредити - Безплатна цена",
    creditsInterDepartmentTransfer: "Кредити - Прехвърляне между отдели",
    otherAdjustment: "Други корекции",
    netConsumption: "Нетно потребление",
    netBeverageSales: "Нетни продажби на напитки",
    netFoodSales: "Нетни продажби на храни",
    costOfSales: "Разходи за продажби",
    debitCost: "Дебитна цена",
    generalSetup: "Общи настройки",
    onlyShowSameQuantity: "Покажи само същото количество",
    excludedHotel: "Изключен хотел",
    idExcludedAutomatically: "ИД-та под {item} са автоматично изключени",
    ileDocumentNo: "Номер на документа ILE",
    adjust: "Настрой",
    importFromExcel: "Импорт от Excel",
    chooseFile: "Изберете файл",
    previewData: "Преглед на данни",
    adjustingPleaseWait: "Настройване, моля изчакайте...",
    showCoaDestination: "Покажи дестинация на COA",
    defaultPrintShowCoaDestination: "Стандартен печат Покажи дестинация на COA",
    directExpense: "Пряка разходна сума",
    movementType: "Тип движение",
    excelFile: "Excel файл",
    businessRegistrationNumber: "Номер на регистрация на фирма",
    appliedInMalaysia: "В момента приложено в Малайзия",
    inventoryAvailableFormula: "Отваряне + Входящо + Дебит",
    grossConsumptionFormula: "Наличен - Затваряне",
    otherAdjustmentFormula: "Бруто потребление - Комплиментарна цена - Между отдели",
    journalDetail: "Детайли на журнала",
    sohDate: "SOH Дата",
    revaluationJournal: "Журнал за преоценка",
    revaluateCost: "Преразгледайте разходите",
    purchaseCost: "Цена на покупката",
    getPurchaseCost: "Получете цената на покупката",
    valueEntriesToAdjust: "Въведете стойности за корекция",
    getValueEntriesToAdjust: "Получаване на стойностни записи за корекция",
    processAdjustment: "Регулиране на процеса",
    updateUnitCost: "Обнови цена на единица",
    unitCostPurchase: "Цена на единица",
    expectedTotalCost: "Очаквана обща цена",
    currentTotalCost: "Текуща обща цена",
    currentUnitCost: "Текуща цена на единица",
    purchaseUnitCost: "Цена на единица",
    diffUnitCost: "Разход за единица",
    locationID: "Идентификатор на местоположение",
    minimumCostDifference: "Минимална разлика в цената",
    showInvoiceTaxBreakdown: "Покажи детайли за данъка по фактурата",
    documentStartDate: "Начална дата на документа",
    documentEndDate: "Дата на край на документа",
    beginning: "Начало",
    beginningQty: "Начално количество",
    beginningValue: "Начална стойност",
    incomingQty: "Постъпващо количество",
    outgoingQty: "Изходящо количество",
    endingQty: "Крайно количество",
    endingValue: "Крайна стойност",
    averagePrice: "Средна цена",
    changeAppliedSalesInvoiceID: "Променен ID на фактура за продажба",
    currentAppliedSalesInvoiceID: "Текущ ID на приложената фактура за продажба",
    newAppliedSalesInvoiceID: "Нови приложени ID на фактура за продажба",
    changeAppliedID: "Променен ID",
    taxNo: "Данъчен номер",
    taxID: "Данъчен идентификатор",
    showTaxForm: "Покажи данъчна форма",
    taxNoLabel: "Номер на данък",
    taxIDLabel: "Идентификационен номер за данъци",
    additionalTopMargin: "Допълнителен горен марж",
    additionalTopMarginHints: "Допълнително горно пространство за печат на фактура",
    endingBalance: "Крайно салдо",
    ledgerMutation: "Промяна на главната книга",
    display: "Показване",
    receiptDate: "Дата на разписка",
    aging: "Стареене",
    detailByDay: "Детайли по дни",
    showPODetail: "Покажи детайли на ПО",
    logNo: "Номер на запис",
    itemJournalLogSeries: "Серия на журнал за артикули",
    printOptions: "Опции за печат",
    allowChangeUnitCostGreaterThanOriginal: "Позволи промяна на единичната цена, по-голяма от оригиналната",
    allowChangeUnitCostLessThanOriginal: "Позволи промяна на единичната цена под оригиналната",
    actual: "Действителен",
    deliveryNo: "Номер на доставка",
    showVendorDeliveryNoOnPrintout: "Покажи номер за доставка на доставчика на разпечатката",
    amountWithCurrency: "Сума ({c})",
    balanceWithCurrency: "Баланс ({c})",
    centerHotelLogo: "Покажи логото на хотела в центъра на хартията",
    isFreeOfCharge: "Безплатно",
    businessRegistrationNumberNew: "Регистрационен номер на фирмата (нов)",
    businessActivityDescription: "Описание на търговската дейност",
    sstRegistrationNumber: "Регистрационен номер по SST",
    msicCodeNumber: "Номер на код MSIC",
    msicDescription: "Описание на MSIC",
    totalBalance: "Обща сума",
    showPostingDateColumn: "Покажи колона с дата на публикуване",
    tin1Label: "ЕИК 1",
    tin1Value: "Стойност на ТИН 1",
    tin2Label: "Етикет ТИН 2",
    tin2Value: "Стойност на ТИН 2",
    welcomeText: "Уважаеми господине/госпожо,  \nБлагодарим ви, че избрахте {h} - прилагаме следната фактура:",
    showWithdrawApproval: "Покажи одобрение за теглене",
    paidAmount: "Платена сума",
    remaining: "Оставащи",
    allowCreateNewSetPaymentJournal: "Позволи създаване на нов комплект платежен журнал",
    allowCreateNewSetCashReceiptJournal: "Позволи създаване на нов комплект за журнал на касови приходи",
    journalNotAllowForDirectPosting: "Журналите за {f} не са разрешени за директно публикуване",
    journalHasZeroValue: "Дневници за {f}, нямат стойност",
    journalNotBalanced: "Дневници за {f}, не балансирани",
    showPreviousMonthAdjustment: "Покажи корекции за предишните месеци",
    noDimensionValue: "(Без размер)",
    isPreviousMonth: "Предишен месец",
    showAdjustmentEntry: "Покажи корекция",
    adjustmentSource: "Източник на корекция",
    distributeAmount: "Разпределете сума",
    distributeAmountEnablement: "Добавете поне една банкова сметка, за да активирате тази опция",
    distributeAmountMessage: "Това автоматично ще разпредели общата сума към банковата сметка",
    allowChangeItemLastDirectCost: "Позволи промяна на последната директна цена на артикула",
    allowDirectReleasePO: "Позволи директно освобождаване на ПО",
    useSystematicApprovalDML: "Използвайте системно одобрение (DML)",
    allowFreeOfChargeOnDirectExpense: "Разреши безплатно за директни разходи",
    statistic: "Статистика",
    chequeNumber: "Номер на чек",
    showSignatureOnApproval: "Покажи подпис при одобрение",
    setVatProduct: "Настройка на ДДС продукт",
    locations: "Локации",
    allLocations: "Всички локации",
    itemCodeOrItemName: "Код на артикула или име на артикула",
    account: "Профил",
    onBehalfOfLabel: "От името на етикет",
    sendEmail: "Изпрати имейл",
    useHOAInvoice: "Използвай фактура на HOA",
    telephone: "Телефон",
    mobilePhone: "Мобилен телефон",
    purchaseOrderNO: "Номер на поръчка",
    requestNo: "Заявка №",
    costCenter: "Разходен център",
    tax: "Данък",
    loc: "Лок",
    uom: "Ед. м.",
    qty: "Бр.",
    dis: "Дис",
    supplierAddress: "Адрес на доставчика",
    voucherNo: "Номер на ваучер",
    refNo: "Реф. номер",
    paymentDueDate: "Срок за плащане",
    bankCode: "Банков код",
    showAsGroup: "Покажи като {s} група",
    showAllVendor: "Покажи всички доставчици",
    affectedData: "Засегнати данни",
    newPostingDate: "Нова дата на публикуване",
    hide: "Скрий",
    downloadPrintoutPDF: "Изтеглете PDF разпечатка",
    taxNumberSeries: "Серия на данъчен номер",
    taxCompany: "Данъчна компания",
    taxExpiryDate: "Срок на данъка",
    taxPhone: "Данъчен телефон",
    taxEmail: "Данъчен имейл",
    taxReceiptNo: "Номер на данъчна разписка",
    unitNo: "Номер на единица",
    unitOwnerName: "Име на собственик на единица",
    company: "Компания",
    selectedItems: "Избрани елементи",
    hoaCompanyName: "Име на HOA компания",
    hoaRoomType: "Тип стая HOA",
    hoaUnitNo: "Номер на единица HOA",
    emailTemplate: "Шаблон за имейл",
    salesInvoiceSendEmailTemplate: "Шаблон за изпращане на имейл за фактура",
    templateVariables: "Шаблонни променливи",
    exampleTemplate: "Примерен шаблон",
    invoiceLabelSetup: "Настройка на етикет за фактура",
    updatePurchaseOrderStatus: "Обнови статус на поръчка",
    updatePurchaseOrderStatusDescription: "Изберете нов статус за поръчката от падащото меню по-долу.",
    currentStatus: "Текущ статус",
    newStatus: "Нов статус",
    preview: "Преглед",
    sortBy: "Сортиране по",
    allowEditPurchaseRequestInApproval: "Позволи редакция на заявка за покупка в одобрение",
    allowEditPurchaseRequestInApprovalNote: "Само потребители, които НЕ са в списъка за одобрение, могат да редактират. Това работи заедно с разрешението 'Позволи на потребителя да променя PR в одобрение'.",
    processToPoCopyDescription: "Процес за копиране на описание на ПО",
    show0Quantity: "Покажи 0 количество",
    selectedLocations: "Избрани локации",
    selectedInventoryPostingGroups: "Избрани групи за публикуване на инвентар",
    noItemsSelected: "Няма избрани елементи",
    noLocationsSelected: "Няма избрани локации",
    noInventoryPostingGroupsSelected: "Не са избрани групи за запис на наличности",
    vendorSource: "Източник на доставчик",
    downloadCSV: "Изтегли CSV",
    delegatedBy: "Делегирано от",
    showCustomerAccountType: "Покажи тип клиентска сметка",
    printGeneralLedgerInformationonPostedDocument: "Печат на информация за главната книга в публикуван документ",
    submittedAt: "Подадено на",
    submittedBy: "Подадено от",
    withdrawalAt: "Изтегляне на",
    withdrawalBy: "Изтегляне от",
    expectedDueDate: "Очаквана / Срок",
    documentApprovalType: "Тип одобрение на документ",
    useExtendedPRDescriptionLength: "Използвайте разширена дължина на PR описанието (255 знака)",
    allowMultilineDescription: "Позволи многострочно описание на PR/PO",
    showUpdateLowestCostVendorComparisonPurchaseRequest: "Покажи сравнение на най-ниските цени на доставчици в заявка за покупка",
    printPreview: "Преглед на печат",
    descriptionMultiLineHint: "Натиснете Enter или напишете ; (точка и запетая), за да добавите нов ред",
    appliesToPostedPurchaseCreditMemoId: "Приложен кредитен меморандум за покупка",
    createPaymentJournal: "Създаване на платежен журнал",
    createCashReceiptJournal: "Създаване на журнал за касови приходи",
    lockPostingDateTheSameAsWorkingDateInFO: "Заключи датата на публикуване същата като работната дата в FO",
    lockPostingDateTheSameAsWorkingDateInFONote: "За журнал за приходи в брой и журнал за съвпадение на сметки",
    totaling: "Общо",
    defaultDimensionValue: "Стандартна стойност на измерение",
    dimensionSetID: "Идентификатор на набор от размери",
    dimensionName: "Име на измерение",
    dimensionCode: "Код на размерите",
    optionCode: "Код на опцията",
    defaultValueCode: "Код по подразбиране",
    allowed: "Разрешено",
    allowedValueCode: "Код на разрешената стойност",
    dimensionValueName: "Име на стойност за размер",
    dimensionValueCode: "Код на стойност на измерение",
    selectAllowedDimensionValues: "Изберете разрешени стойности за тази измерение",
    selectDimensionToViewAllowedValues: "Изберете размер, за да видите допустимите стойности",
    selectedValues: "Избрани стойности",
    showPositive: "Покажи положителни",
    showBankAccountOnPaymentListReport: "Покажи банкова сметка в отчета за всички плащания",
    footerFontType: "Тип шрифт на футера",
    standardFontHint: "Стандартен шрифт от системата",
    monospaceFontHint: "Всеки символ, включително букви, цифри и интервали, заема еднаква хоризонтална ширина",
    signatureAlignment: "Подравняване на подпис",
    allowEditReleasedPOLineZeroQtyReceived: "Позволи редакция на отворени и освободени ПП линии, когато количеството е нула",
    overridePrLineFromPo: "Замяна на PR ред при промяна на PO ред",
    month1: "1 Месец",
    month2: "2 Месеца",
    month3: "3 Месеца",
    month4: "4 месеца",
    moreThan4Months: "> 4 месеца",
    printingDateTime: "Дата и час на печат",
    disc: "Диск",
    allowDeletePrSourcedPoLine: "Позволи изтриване на PO редове от PR (възстановява PR реда в Отворен)",
    purchaseRequestExpiredRange: "Изтекъл период за заявка за покупка (дни)",
    purchaseOrderExpiredRange: "Изтекъл срок на поръчка (дни)",
    enablePrintButtonForOnlyReleasedDocuments: "Активирайте бутона за печат само ако статусът на документа е Освободен",
    currentDimensionSetID: "Текущ ID на набор от размери",
    newDimensionSetID: "Идентификатор на нов комплект размери",
    lastMovement: "Последно движение",
    age: "Възраст",
    soh: "СОХ",
    changeGLAccount: "Промяна на GL сметка",
    postPurchaseInvoice: "Фактура след покупка",
    draft: "Чернова",
    setZeroQuantityPhysicalAsBlank: "Остави 0 количество (физическа инвентаризация) празно",
    reviewYtdReportComparisonYear: "Преглед на сравнение на YTD отчет за годината",
    reviewPnlYtdSummaryComparisonYear: "Обобщение на печалба и загуба от началото на годината - Сравнение на годината",
    reviewPnlYtdConsolidationComparisonYear: "Сравнение на консолидирана печалба и загуба от началото на годината",
    reviewBalanceSheetYtdSummaryComparisonYear: "Сравнение на балансова ведомост YTD за годината",
    budget: "Бюджет",
    taxRegisterNumber: "Номер на данъчен регистър",
    purchaseReceiptNo: "PR №",
    purchaseReceiptPostingDate: "Дата на публикуване на PR",
    amountDue: "Дължима сума",
    periodDate: "Дата на периода",
    parafInitial: "Параф / Инициали",
    appliesToPostedPurchaseInvoiceNo: "Номер на приложена фактура за покупка",
    showContactNameOnPrintSummary: "Покажи името на контакта в печатното резюме",
    depositAccountCode: "Код на депозитна сметка",
    depositAccountName: "Име на депозитна сметка",
    boDepositAccountCode: "Код на депозитна сметка BO",
    boDepositAccountName: "Име на депозитна сметка",
    foDepositAccountNo: "Номер на депозитна сметка FO",
    foDepositAccountName: "Име на депозитна сметка FO",
    depositAccountPostingGroupCode: "Код на група за запис на депозитна сметка",
    depositAccountPostingGroupName: "Име на група за запис на депозитни сметки",
    appliedDepositAccountLedgerEntryId: "Приложен Ид",
    showInDocument: "Покажи в документа",
    showInDocumentHint: "Нивата, отбелязани с Показване в документа, добавят колоните Код и Име към: Заявка за покупка, Поръчка за покупка, Прием на покупка, Фактура за покупка, Кредитно известие за покупка, Заявка за магазин, Фактура за продажба, Кредитно известие за продажба, Общ журнал, Журнал за общ бюджет, Журнал за артикули, Журнал за физическа инвентаризация",
    automaticFillInvoiceNo: "Автоматично попълване на фактура № с номер на доставка на доставчика",
    useGeneralBudgetEntryForPnlBudget: "Използвайте общо бюджетно въвеждане за бюджет на П&Л",
    recalledAt: "Отзован на",
    recalledBy: "Изтеглено от",
    hideUnitCostColumn: "Скрий колона \"Цена на единица",
    hideTotalAmountColumn: "Скрий колоната с общата сума",
    showPrintedDateTime: "Покажи дата и час на печат",
    printedAt: "Отпечатано на",
    includedInGop: "Включено в GOP",
    bankAccountName: "Име на банкова сметка",
    chargeDate: "Дата на таксуване",
    banquet: "Банкет",
    secondaryAccountNo: "Номер на вторичен акаунт",
    currentStockOnHand: "Текущо SOH",
    baseCurrentStockOnHand: "Базова текуща SOH",
    showCurrentSohInPurchaseRequest: "Покажи текущия SOH в заявка за покупка",
    showCurrentSohInPurchaseOrder: "Покажи текущия SOH в поръчката",
    allowPositiveAdjustmentPhysicalInventory: "Позволи положителна корекция в физическия инвентарен журнал",
    dimensionValueID: "ID на стойност на размер",
    purchaseRequestMaxBackdatedDays: "Максимален брой дни назад",
    purchaseOrderMaxBackdatedDays: "Максимален брой дни назад",
    purchaseInvoiceMaxBackdatedDays: "Максимален брой дни назад",
    storeRequisitionMaxBackdatedDays: "Максимален брой дни назад",
    newQuantity: "Ново количество",
    editQuantity: "Редактиране на количество",
    requestedQuantity: "Заявено количество",
    allowApproverEditQuantityLessThanOriginal: "Позволи на одобряващия да редактира количество под оригиналното",
    wht: "БЯЛ",
    hideWhtWhenZero: "Скрий WHT, когато сумата е нула",
    useImportWithReservation: "Използвай Импорт с Резервация",
    includeReservationDetail: "Включи детайли за резервация",
    contractValidFrom: "Договорът е валиден от",
    contractValidTo: "Договорът е валиден до",
    reconciliationWhtGlAccount: "Счетоводство на удържан данък",
    whtAccountMustDiffer: "Сметката за удържан данък трябва да е различна от основната сметка",
    whtFee: "Данък удръжка (%)",
    paymentStatus: "Статус на плащането",
    useCompanyHeaderAndLogoOnPrintout: "Използвайте заглавие на компанията и лого в заглавието на разпечатката",
    supplierAndHotelVatLabel: "Етикет ДДС на доставчик и хотел",
    supplierInfo: "Информация за доставчика",
    shipToBillTo: "Доставка до / Фактура до",
    batchHasWhtFee: "Върху тази партида се прилага данък удръжка <strong>{f} %</strong>.",
    batchHasWhtOptions: "Данък върху доходите:",
    freePercentage: "Безплатен процент",
    feeRoundingDigits: "Закръгляне на такси (0-3)",
    feeRoundingDigitsRange: "Цифрите за закръгляне на таксата трябва да са цяло число от 0 до 3",
    reconciliationFeeRoundingDigits: "Закръгляне на таксата за помирение (0-3)",
    reconciliationFeeRoundingDigitsHint: "Десетични знаци за търговски отстъпки и данък върху доходите в Журнал за съгласуване на сметки",
    creditAccountName: "Име на кредитна сметка",
    debitAccountName: "Име на дебитна сметка",
    defaultCreditAccountName: "Име на основна кредитна сметка",
    defaultDebitAccountName: "Име на основна дебитна сметка",
    defaultCreditAccount: "Основна кредитна сметка",
    defaultDebitAccount: "Основна дебитна сметка",
    chequeNo: "Номер на чек",
    allowOverReceipt: "Позволи надвишаване на количеството на касовата бележка",
    overReceiptTolerancePercentage: "Толеранс на количество над разписка (%)",
    inventoryAdjustmentAccountCode: "Код за корекция на инв.",
    inventoryAdjustmentAccountName: "Име на сметка за корекция на инв.",
    genBusPostGroupName: "Ген. бизнес. публикация. Име на група",
    aePurchasingAccount: "Сметка за покупки A/E",
    accrualJournalBatch: "Партида на журнал за натрупване",
    accrualJournalBatchTemplate: "Партида на журнал за начисления (шаблон за начисления)",
    accrualDate: "Дата на натрупване",
    quantityToAccrue: "Количество за натрупване",
    mdrOptionsPerBatch: "Процент на отстъпка за търговци (всяка партида използва своя ставка):",
    batchWhtRate: "Скорост на партида",
    batchAccountTotals: "Общо по сметка",
    createReconciliationJournal: "Създаване на журнал за съгласуване",
    message: "Съобщение",
    postAllBatchResultTitle: "Публикувай всички резултати от партидата",
    postAllBatchSummary: "{succeeded} успешно, {failed} неуспешно, {skipped} пропуснато",
    postAllBatchNothingToPost: "Няма партиди с записи за публикуване.",
    deleteAllBatchNothing: "Няма партиди с записи за изтриване.",
    deleteAllBatchSummary: "{изтрито} партиди изпразнени, {неуспешни} неуспешни",
    postAllBatchEmpty: "Партидата няма записи",
    postAllBatchStatus: {
      succeeded: "Успяно",
      failed: "Неуспешно",
      skipped: "Пропуснато",
    },
    displayGuestAsGuestList: "Покажи госта като списък с гости",
    debitDimensions: "Дебитни размери",
    creditDimensions: "Кредитни размери",
    saveBatchFirstForDimensions: "Запазете партидата с тази сметка първо, за да зададете размерите",
  },
  validation: {
    baseRequired: "Полето е задължително",
    required: "{f} е задължително",
    longerThan: "{f} не трябва да е по-дълго от {v} знака",
    generalProductPostingGroupRequired: "Общата група за осчетоводяване на продукти е задължителна, моля изберете от падащото меню",
    inventoryPostingGroupRequired: "Група за осчетоводяване на склад е задължителна, моля изберете от падащото меню",
    baseUnitOfMeasurementRequired: "Базова мерна единица е задължителна, моля изберете от падащото меню",
    defaultUnitOfMeasurementRequired: "Стандартна мерна единица е задължителна, моля изберете от падащото меню",
    lineMoreThan: "{f} редът не трябва да е повече от {v} реда",
    exceed: "{f} не трябва да надвишава {v}",
    dateNotAfter: "'{f1}' датата не трябва да е след '{f2}'",
    dateNotBefore: "„Дата '{f1}' не трябва да е преди '{f2}'“",
    dateNotBefore2: "{f1} датата не трябва да е преди {f2} датата ({f3})",
    dateNotBefore3: "{f1} датата не трябва да е преди {f2} датата",
    unitCostExceedOrBelowLastPrice: "Цената на единица не може да бъде над {v1} или под {v2} от последната цена",
    greaterThan: "Стойността трябва да е по-голяма от {v}",
    max20Lines: "Низът не трябва да надвишава 20 реда",
    maxLines: "Низът не трябва да надвишава {f} реда",
    completeRequiredFields: "Моля, попълнете всички задължителни полета преди публикуване. Проверете маркираните полета в таблицата.",
    cannotPostWhenUseSystematicApproval: "Не може да се публикува фактура при системно одобрение",
    dimensionAlreadyInList: "Тази стойност вече съществува в списъка. Редактирайте този ред вместо да добавяте нов.",
    incompleteDimensionRow: "Всяки ред изисква измерение и стойност. Попълнете или премахнете незавършения ред.",
    dimensionsNotLoaded: "Настоящите размери не могат да бъдат заредени. Затворете и отворете отново този диалог преди да запазите.",
    linesTotalCannotBeNegative: "Общата сума на всички редове не може да е отрицателна",
    fourDigitYear: "Въведете 4-цифрена година",
    physicalQuantityNegative: "Физическото количество не може да бъде отрицателно. Въведете измереното количество (0, ако няма).",
    maxBackdatedDaysRange: "Въведете цяло число дни между 0 и 30",
    quantityGreaterThanRequested: "Количество не може да е по-голямо от поисканото ({v})",
    contractValidToBeforeFrom: "Краен срок на договора не може да е по-рано от Начален срок на договора",
    idtDeleteOnlyOpen: "Може да се изтрие само непубликуван трансфер с отворен или отказан статус.",
    overReceiptToleranceRange: "Въведете процент над 0 и до 999.99, с до 2 десетични знака",
    overReceiptMaxAllowed: "{f} не може да надвишава {v}, максималното разрешено на този ред",
  },
  textFormat: {
    addFromReceipt: "Добавено от разписка : {f} ",
  },
  l: {
    add: "Добави",
    addCashDesk: "Добави каса",
    addChannel: "Добави канал",
    addCity: "Добави град",
    addChannelClientCompositionMapping: "Добави съпоставяне на клиентски състав на канал",
    addChannelHotelRateCodeMapping: "Добави съпоставяне на хотелски тарифен код на канал",
    addChannelHotelRoomTypeMapping: "Добави съпоставяне на тип стая на канал",
    addCountry: "Добави държава",
    addCreditCardType: "Добави тип кредитна карта",
    addGeneralJournal: "Добави общ журнал",
    addJournalAccountType: "Добави тип сметка в журнал",
    addJournalBatch: "Добави партида в журнал",
    addJournalTemplate: "Добави шаблон на журнал",
    addRoomStatus: "Добави статус на стая",
    addRoomType: "Добави тип стая",
    adminCode: "Админ код",
    adminName: "Админ име",
    adminNameAscii: "Админ име ASCII",
    adminType: "Тип админ",
    backOffice: "Бек офис",
    bankAccount: "Банкова сметка",
    bankAccountId: "ID на банкова сметка",
    beverage: "Напитка",
    beverageToday: "Напитка днес",
    bookingSource: "Източник на резервация",
    breakdownListAt: "Списък с разбивки на",
    breakdownListOf: "Списък с разбивки на",
    cancel: "Отказ",
    cancelProcess: "Отказ на процеса",
    capital: "Капитал",
    cashDesk: "Каса",
    changeClientPostingGroup: "Промени клиентска група за осчетоводяване",
    channel: "Канал",
    channelAgencyCode: "Код на агенция на канал",
    channelClientCompositionMapping: "Съпоставяне на клиентски състав на канал",
    channelHotelRateCodeMapping: "Съпоставяне на хотелски тарифен код на канал",
    channelHotelRoomTypeMapping: "Съпоставяне на тип стая на канал",
    channelId: "ID на канал",
    channelManager: "Мениджър на канал",
    channelRateCode: "Тарифен код на канал",
    channelRoomType: "Тип стая на канал",
    channelRoomTypeCode: "Код на тип стая на канал",
    city: "Град",
    cityAlt: "Алтернативен град",
    cityAscii: "Град ASCII",
    code: "Код",
    country: "Държава",
    countryId: "ID на държава",
    credit: "Кредит",
    creditCard: "Кредитна карта",
    creditCardType: "Тип кредитна карта",
    client: "Клиент",
    clientNo: "Клиентски номер",
    clientLedger: "Клиентска книга",
    currencyID: "ID на валута",
    currencyName: "Име на валута",
    dailyFlashCostReport: "Дневен отчет за разходи",
    dashboard: "Табло",
    defaultBookingSource: "Стандартен източник на резервация",
    defaultMarketSegment: "Стандартен пазарен сегмент",
    delete: "Изтрий",
    deleteConfirmation: "Потвърждение за изтриване",
    density: "Плътност",
    description: "Описание",
    documentNo: "Номер на документ",
    documentType: "Тип документ",
    documentFlowNotFound: "Не е намерен поток на документи с код {f}",
    downloadExcel: "Изтегли Excel",
    downloadGSheet: "Изтегли GSheet",
    downloadPDF: "Изтегли PDF",
    downloadReport: "Изтегли отчет",
    downloadReportToGSheet: "Изтегли отчет към GSheet",
    downloadReportToGSheetMacro: "Изтегли отчет към GSheet (Макро)",
    downloadReportToExcel: "Изтегли отчет към Excel",
    downloadReportToExcelMacro: "Изтегли отчет към Excel (Макро)",
    edit: "Редактирай",
    editCashDesk: "Редактирай каса",
    editChannel: "Редактирай канал",
    editCity: "Редактирай град",
    editChannelClientCompositionMapping: "Редактирай съпоставяне на клиентски състав на канал",
    editChannelHotelRateCodeMapping: "Редактирай съпоставяне на хотелски тарифен код на канал",
    editChannelHotelRoomTypeMapping: "Редактирай съпоставяне на тип стая на канал",
    editCountry: "Редактирай държава",
    editCreditCardType: "Редактирай тип кредитна карта",
    editGeneralJournal: "Редактирай общ журнал",
    editJournalAccountType: "Редактирай тип сметка в журнал",
    editJournalBatch: "Редактирай партида в журнал",
    editJournalTemplate: "Редактирай шаблон на журнал",
    editRoomStatus: "Редактирай статус на стая",
    editRoomType: "Редактирай тип стая",
    editCost: "Редактирай разход",
    editRemainingQuantity: "Редактирай оставащо количество",
    editRemainingAmount: "Редактирай оставаща сума",
    editRemainingAmountWarning: "Внимание: това директно презаписва оставащата сума и статуса на отвореност на осчетоводен запис в главната книга. Проверете свързаните записи след това.",
    internalToolsPostBatchReceipt: "Internal Tools Post Batch",
    internalToolsPostBatchReceiptHint: "Posts released purchase orders for this hotel whose order date falls in the range you set, oldest first, as fully received purchase receipts, up to the limit you set. Receipts are numbered with the prefix exactly as typed, including any trailing space, followed by a running number.",
    internalToolsPostBatchReceiptConfirm: "Post all released purchase orders as fully received purchase receipts?",
    internalToolsPostBatchReceiptFailed: "Failed to post",
    internalToolsPostBatchReceiptNoOrders: "There are no released purchase orders to post.",
    internalToolsPostBatchReceiptDone: "Posted {posted}, failed {failed}.",
    orderDateFrom: "Order Date From",
    orderDateTo: "Order Date To",
    documentNoPrefix: "Document No Prefix",
    documentNoPrefixInvalid: "Prefix contains characters that are not allowed.",
    maxOrdersPerRun: "Max Orders Per Run",
    maxOrdersPerRunInvalid: "Enter a whole number between 1 and {v}.",
    numberingByPrefix: "Prefix",
    editStoreRequisitionPosted: "Редактирай публикувана заявка от магазин",
    entryNo: "Номер на запис",
    failed: "Неуспешно",
    failedToPrint: "Неуспешен печат",
    food: "Храна",
    foodToday: "Храна днес",
    frontOffice: "Рецепция",
    generalJournal: "Общ журнал",
    genProdPostGroupID: "ID на група за осчетоводяване на продукти",
    glAccountID: "ID на GL сметка",
    glAccountName: "Име на GL сметка",
    glAccountNo: "Номер на GL сметка",
    guestNumber: "Номер на гост",
    headerDescription: "Описание на заглавието",
    headerClientName: "Име на клиент в заглавието",
    headerClientAddress: "Адрес на клиент в заглавието",
    hotelAgency: "Хотелска агенция",
    hotelAgencyGroup: "Група хотелски агенции",
    hotelClient: "Клиент на хотел",
    hotelRate: "Тарифа на хотел",
    hotelRoomType: "Тип стая в хотел",
    importUnitCost: "Импортирай единична цена",
    importQuantity: "Импортирай количество",
    iso2Code: "ISO2 код",
    journalAccountNo: "Номер на сметка в журнал",
    journalAccountType: "Тип сметка в журнал",
    journalBatch: "Партида в журнал",
    journalTemplate: "Шаблон на журнал",
    latitude: "Географска ширина",
    lineDescription: "Описание на реда",
    lineLocationID: "ID на местоположение на реда",
    lineLocationName: "Име на местоположение на реда",
    lineNo: "Номер на ред",
    lineUnitOfMeasurementID: "ID на мерна единица на реда",
    lineUnitOfMeasurementName: "Име на мерна единица на реда",
    longitude: "Географска дължина",
    macro: {
      cost: "Макро разход",
      revenue: "Макро приход",
    },
    mandatory: "Задължително",
    marketSegment: "Пазарен сегмент",
    masterData: "Основни данни",
    month: {
      _: "Месец",
      list: {
        full: "['Януари', 'Февруари', 'Март', 'Април', 'Май', 'Юни', 'Юли', 'Август', 'Септември', 'Октомври', 'Ноември', 'Декември']",
        abbr: "['Ян', 'Фев', 'Мар', 'Апр', 'Май', 'Юни', 'Юли', 'Авг', 'Сеп', 'Окт', 'Ное', 'Дек']",
      },
    },
    name: "Име",
    new: "Нов",
    no: "Не",
    numericCode: "Числов код",
    ofCreditComplimentary: "от Кредит - Комплимент",
    ofCreditCover: "от Кредит - Покритие",
    ofCreditOfficeCheck: "от Кредит - Офис чек",
    ofCreditEntertainment: "от Кредит - Забавление",
    ofPurchaseReceipt: "от Разписка за покупка",
    ofStoreRequest: "от Заявка от магазин",
    officialStateName: "Официално име на държавата",
    originalAmount: "Оригинална сума",
    paymentTermID: "ID на платежен срок",
    paymentTermCode: "Код на платежен срок",
    population: "Население",
    populationProper: "Действително население",
    postingDate: "Дата на осчетоводяване",
    rate: "Курс",
    ranking: "Класиране",
    revenueCenterCode: "Код на приходен център",
    roomStatus: "Статус на стая",
    roomType: "Тип стая",
    sameName: "Същото име",
    save: "Запази",
    simpleMapsCityId: "SimpleMapsCity ID",
    successful: "Успешно",
    timezone: "Часова зона",
    vatProdPostGroupCode: "Код на група за ДДС на продукти",
    vatProdPostGroupID: "ID на група за ДДС на продукти",
    whtVatProdPostGroupCode: "Код на група за удържан ДДС",
    whtVatProdPostGroupID: "ID на група за удържан ДДС",
    yes: "Да",
    googleSheets: "Google Sheets",
    debit: "Дебит",
    previousBalance: "Предишен баланс",
    billDate: "Дата на фактурата",
    aged: "Възрастен",
    poNoCoa: "Номер на поръчка / СТ",
    receiptNoDesc: "Номер на разписка / Описание",
    and: "и",
    cents: "стотинки",
    processExpired: "Процесът е изтекъл",
    revertExpired: "Върни изтекло",
    notes: "Бележки",
  },
  m: {
    confirmDelete: "Сигурни ли сте, че искате да изтриете {f}? Този процес не може да бъде отменен.",
    err: {
      betLen: "{f} трябва да бъде между {v1} и {v2} знака",
      ge: "{f} трябва да бъде по-голямо или равно на {v}",
      gt: "{f} трябва да бъде по-голямо от {v}",
      le: "{f} трябва да бъде по-малко или равно на {v}",
      lt: "{f} трябва да бъде по-малко от {v}",
      maxLen: "{f} трябва да бъде максимум {v} знака",
      maxVal: "Максималната стойност на {f} е {v}{x}",
      minLen: "{f} трябва да бъде минимум {v} знака",
      minMaxVal: "Стойността на {f} трябва да бъде от {v1}{x} до {v2}{x}",
      minVal: "Минималната стойност на {f} е {v}{x}",
      number: "{f} трябва да бъде число, положително или отрицателно",
      numeric: "{f} трябва да съдържа само числа",
      req: "{f} е задължително",
    },
    entryEditorWarning: "Уверете се, че счетоводният период остава отворен и че вашият потребителски акаунт има необходимите разрешения за настройка на потребителско осчетоводяване. Всички промени, направени във формата, ще бъдат сигурно записани.",
    entryDeleteWarningUpdate: "Уверете се, че всички данни по-долу ще бъдат отворени отново поради действие за изтриване. Всички промени, направени от това действие, ще бъдат сигурно записани",
    entryDeleteBaleWarningDelete: "Внимание: Продължаването с това действие ще доведе до окончателното премахване на всички записи в банковата книга, свързани с посочения номер на документ. Моля, уверете се, че сте проверили точността на номера на документа, тъй като тази операция е необратима. Всички промени, направени от това действие, ще бъдат сигурно записани",
    errorEmptyDocumentNumber: "Моля, изберете първо номер на документ.",
    successDeleteBale: "Записите в банковата книга са изтрити",
    successDeletePostedInvoice: "Публикуваната фактура е изтрита",
    successMovePurchaseInvoiceLines: "Редовете от фактурата за покупка бяха успешно преместени",
    movePurchaseInvoiceLinesWarning: "Това действие ще премести всички редове от избраната изходна фактура за покупка към целевата фактура за покупка. Моля, уверете се, че сте избрали правилните фактури, тъй като тази операция не може да бъде отменена.",
    pleaseSelectTargetPurchaseInvoice: "Моля, изберете целева фактура за покупка",
    sourceTargetPurchaseInvoiceCannotBeSame: "Изходната и целевата фактури за покупка не могат да бъдат еднакви",
    setVendorChangePriceReminder: "Цената ще се определя въз основа на договорната цена на доставчика, когато такава цена е налична",
    successChangeStatusPurchaseRequisition: "Статусът на заявката за покупка е актуализиран",
    successImportGlb: "Бюджетът на главната книга е импортиран успешно!",
    successSaveGlb: "Бюджетът на главната книга е запазен успешно!",
    entryDeleteCleWarningDelete: "Внимание: Продължаването с това действие ще доведе до окончателното премахване на всички клиентски записи, свързани с посочения номер на документ. Моля, уверете се, че сте проверили точността на номера на документа, тъй като тази операция е необратима. Всички промени, направени от това действие, ще бъдат сигурно записани",
    entryDeleteVleWarningDelete: "Внимание: Продължаването с това действие ще доведе до окончателното премахване на всички записи на доставчика, свързани с посочения номер на документ. Моля, уверете се, че сте проверили точността на номера на документа, тъй като тази операция е необратима. Всички промени, направени от това действие, ще бъдат сигурно записани",
    successDeleteCle: "Клиентските записи са изтрити",
    successDeleteVle: "Записите на доставчика са изтрити",
    successUpdateWitholdingTax: "Удържаният данък е актуализиран",
    successChangeClientSales: "Клиентът е актуализиран",
    confirmLogout: "Сигурни ли сте, че искате да излезете?",
    confirmFlushSiteData: "Сигурни ли сте, че искате да изчистите данните на сайта? Това ще ви излезе и ще презареди страницата.",
    successFlushSiteData: "Данните на сайта са изчистени. Ще бъдете излезли и страницата ще се презареди.",
    successChangeBankAccount: "Банковата сметка е променена",
    currBankAccount: "Текуща банкова сметка",
    successChangeVendor: "Доставчикът е променен",
    currVendor: "Текущ доставчик",
    successChangeDeliveryNo: "Номерът на доставка е променен",
    currDeliveryNo: "Текущ номер на доставка",
    newDeliveryNo: "Нов номер на доставка",
    pleaseSelectPurchaseInvoiceFromTheList: "Моля, първо изберете фактура от списъка",
    entryDeleteVeWarningDelete: "Внимание: Продължаването с това действие ще доведе до постоянно изтриване на всички стойности, свързани с посочения номер на документа. Моля, уверете се, че сте проверили точността на номера на документа, тъй като тази операция е необратима. Всички изменения от това действие ще бъдат сигурно записани.",
    successDeleteVe: "Записите за стойности са изтрити",
    entryDeleteGjeWarningDelete: "Внимание: Продължаването с това действие ще доведе до постоянно изтриване на всички записи в общия журнал, свързани с посочения номер на документа. Моля, уверете се, че сте проверили точността на номера на документа, тъй като тази операция е необратима. Всички изменения от това действие ще бъдат сигурно записани.",
    deleteGeneralJournalLogWarning: "Това няма да изтрие записи в главната книга, само този лог.",
    revertPostedInvoiceWarning: "Тази операция ще премахне всички свързани записи в главната книга и ще зададе документа за покупка като чернова или непубликуван.",
    deletePostedInvoiceWarning: "Тази операция ще премахне всички свързани записи в главната книга и документа за покупка.",
    changeCOAAndDescriptionWarning: "Тази операция ще актуализира само от реда на фактурата за покупка. Моля, уверете се, че актуализациите се извършват отделно в Записите на главната книга.",
    successCreatePaymentJournal: "Създаден е журнал за плащания",
    successCreateCashReceiptJournal: "Създаден е журнал за касови приходи",
    failedZeroRemainingAmount: "Не може да продължите. Някои данни имат нулева остатъчна сума.",
    failedAppliedEntries: "Не може да продължи. Някои данни са приложени към плащането.",
    remainingAmountNotEqualOriginalAmount: "Останалата сума не е равна на първоначалната сума",
    deletePostedPurchaseCreditMemoWarning: "Тази операция ще премахне всички свързани записи в главната книга и документа за кредитно известие за покупка.",
    successDeletePostedMemo: "Публикуваната бележка е изтрита",
    revertPostedPurchaseCreditMemoWarning: "Тази операция ще премахне всички свързани записи в главната книга и ще зададе документа за кредитно известие като чернова или непубликуван.",
    ytdComparisonYearHint: "Брой допълнителни исторически години в отчета (0-3, 0 = изключено)",
    entryDeleteDaleWarningDelete: "Внимание: Продължаването с това действие ще доведе до постоянно изтриване на всички записи в депозитния акаунт, свързани с посочения номер на документа. Моля, уверете се, че сте проверили точността на номера на документа, тъй като тази операция е необратима. Всички изменения от това действие ще бъдат сигурно записани.",
    successDeleteDale: "Записите на депозитната сметка са изтрити",
    successChangeClient: "Клиентът е променен",
    currClient: "Текущ клиент",
    revertPostedInterDepartmentTransferWarning: "This action will remove all related Ledger Entries and set the Inter Department Transfer as unposted. It stays released and can be posted again.",
    successChangeDepositAccount: "Сметката за депозит е променена",
    currDepositAccount: "Текуща депозитна сметка",
    noDimensionsConfigured: "Все още няма конфигурирани размери за този отчет.",
    noDimensionsAvailable: "Всички размери на хотела вече са добавени.",
    dimensionCountNone: "няма размери",
    dimensionCountOne: "1 размер",
    dimensionCountMany: "{count} размера",
    saveDimensionOrderFirst: "Запазете текущия ред, преди да добавите друг размер.",
    gbeRecallWarning: "Връщането на този документ трайно премахва записите му от Общия бюджет. Записите са архивирани и могат да бъдат прегледани под Върнати. За да ги възстановите, въведете отново редовете в Общия бюджетен журнал и публикувайте отново.",
    gbeRecallSuccess: "{n} записа за бюджетa възстановени.",
    deleteSelectedInvoicesWarning: "Тази операция ще премахне трайно избраните фактури и всички техни редове. Не може да бъде отменена.",
    deleteSelectedInvoicesCount: "{v} документа/документа ще бъдат изтрити:",
    invoiceWithoutDocumentNo: "(Няма номер на документа)",
    purchaseBookSummaryTruncated: "Общите суми обхващат само първите {v} записа. Стеснете диапазона на датите за точна сума.",
    changeAccountNumberDimensionNotice: "Наборът от размери на този запис ще бъде заменен с долупосочените стойности, предварително попълнени от задължителните размери на {account}. Оставете списъка празен, за да премахнете набора от размери.",
    changeAccountNumberDimensionAssignNotice: "Тази записка няма зададени размери. {account} изисква следните размери, предварително попълнени с техните стойности по подразбиране. Потвърдете или коригирайте преди запазване.",
    successImportCfb: "Бюджетът на паричния поток е импортиран успешно!",
    successSaveCfb: "Бюджетът за паричен поток е запазен успешно!",
    expenseAllocationSelectGroup: "Изберете обща група за публикуване на продукти в таба Информация, за да видите комбинациите за публикуване.",
    expenseAllocationLoadFailed: "Не можа да зареди нивата на измерението. Отворете таба отново, за да опитате.",
    accrualSetupMissing: "Генерирането на начисления не може да се изпълни. Първо задайте {f} в Настройките на задълженията за покупки (вкладка Други).",
    accrualPeriodAlreadyPosted: "Натрупването за {f} вече е публикувано. Повторно изпълнение за този месец не е разрешено.",
    accrualDateNotMonthEnd: "{f} не е крайна дата за месеца. Обратното все още се записва на {r}.",
    accrualNoCandidates: "Няма получени G/L покупки, чакащи фактура към {f}.",
    accrualReplaceNotice: "Непубликувани редове от партида {b} с дата {f} ще бъдат заменени.",
    accrualSelectedTotals: "{n} избрани реда",
    successGenerateAccrual: "Натрупване генерирано в партида {b}: записани {n} реда, заменени {d} незаписани реда.",
    successCreateReconciliationJournal: "Създаден е журнал за помирение: {f}",
    failedClosedEntries: "Не може да продължите. Някои избрани записи са затворени.",
    reconciliationJournalPerBankAccount: "{n} документа(и) ще бъдат създадени, по един за всяка банкова сметка",
  },
  common: {
    add: "Добави",
    cancel: "Отказ",
    description: "Описание",
    delete: "Изтрий",
    title: "Заглавие",
    save: "Запази",
    faq: "ЧЗВ",
    contact: "Свържете се с нас",
    tos: "Условия за ползване",
    policy: "Политика за поверителност",
    sunday: "Неделя",
    monday: "Понеделник",
    tuesday: "Вторник",
    wednesday: "Сряда",
    thursday: "Четвъртък",
    friday: "Петък",
    saturday: "Събота",
    clickHere: "Кликнете тук",
    standard: "Стандартен",
    monospace: "Моноширинен",
    left: "Ляво",
    center: "Център",
    right: "Дясно",
  },
  board: {
    titlePlaceholder: "Въведете заглавие за тази карта",
    deleteDescription: "Сигурни ли сте, че искате да изтриете тази карта?",
    editCard: "Редактирай карта",
    deleteCard: "Изтрий карта",
    state: {
      TODO: "ЗА ПРАВЕНЕ",
      INPROGRESS: "В ПРОЦЕС",
      TESTING: "ТЕСТВАНЕ",
      DONE: "ГОТОВО",
    },
  },
  chat: {
    online: "Потребители онлайн ({count})",
    addChannel: "Добави канал",
    channel: "Канал | Канали",
    message: "Съобщение",
  },
  email: {
    compose: "Създай имейл",
    send: "Изпрати",
    subject: "Тема",
    labels: "Етикети",
    emptyList: "Списъкът с имейли е празен",
    inbox: "Входящи",
    sent: "Изпратени",
    drafts: "Чернови",
    starred: "Със звезда",
    trash: "Кошче",
    work: "Работа",
    invoice: "Фактура",
    recipient: "Получател",
  },
  todo: {
    addTask: "Добави задача",
    tasks: "Задачи",
    completed: "Завършени",
    labels: "Етикети",
  },
  dashboard: {
    activity: "Активност",
    weeklySales: "Седмични продажби",
    sales: "Продажби",
    recentOrders: "Последни поръчки",
    sources: "Източници на трафик",
    lastweek: "спрямо миналата седмица",
    orders: "Поръчки",
    clients: "Клиенти",
    tickets: "Билети за поддръжка",
    viewReport: "Виж отчет",
  },
  usermenu: {
    profile: "Профил",
    signin: "Вход",
    dashboard: "Табло",
    signout: "Изход",
  },
  error: {
    differentVATGroup: "Групите за ДДС на продуктите трябва да са еднакви",
    glbImport: "Грешка, не може да се импортира бюджет на главната книга",
    notfound: "Страницата не е намерена",
    other: "Възникна грешка",
    invoiceAlreadyHaveCreditMemo: "Тази фактура вече има кредитно известие",
    POItemIsFromPR: "Артикулът в поръчката за покупка идва от заявка за покупка",
    locationAndPostingGroupDuplicate: "Това местоположение ({f1}) и група за осчетоводяване ({f2}) вече съществуват.<br/>Моля, изберете друга стойност!",
    businessAndProductPostingGroupDuplicate: "Този бизнес ({f1}) и група за осчетоводяване на продукти ({f2}) вече съществуват.<br/>Моля, изберете друга стойност!",
    invoiceAlreadyPaid: "Тази фактура е платена частично или изцяло.<br/>Оригинална сума: {f1}<br/>Оставаща сума: {f2}",
    needConfigureVatProduct: "Моля, настройте група за ДДС на продуктите в настройките на клиента или вземанията",
    failedFetchItemCost: "Неуспешно извличане на последната цена на артикула",
    syncPrLineFailed: "Неуспешно синхронизиране на промените в реда на заявката за покупка. Промените в поръчката са запазени.",
    needConfigureDirectCostAccount: "Моля, настройте сметката за директни разходи в настройките на задълженията по покупки",
    needConfigurePurchaseAccount: "Моля, настройте сметка за покупки в настройките за плащания.",
    noPermission: "Нямате разрешение да извършите това действие",
    cfbImport: "Грешка, не може да се импортира бюджет за паричен поток",
    noAppliedEntriesOnThisDocument: "Няма приложени записи в този документ",
    noCompanyHeaderInfo: "Няма информация за заглавие на компанията. Моля, свържете се с администратора си.",
  },
  check: {
    title: "Задайте нова парола",
    backtosign: "Обратно към вход",
    newpassword: "Нова парола",
    button: "Задайте нова парола и влезте",
    error: "Връзката за действие е невалидна",
    verifylink: "Проверка на връзката...",
    verifyemail: "Проверка на имейл адреса...",
    emailverified: "Имейлът е потвърден! Пренасочване...",
  },
  forgot: {
    title: "Забравена парола?",
    subtitle: "Въведете имейл адреса на акаунта си и ще ви изпратим връзка за нулиране на паролата.",
    email: "Имейл",
    button: "Заяви нулиране на парола",
    backtosign: "Обратно към вход",
  },
  login: {
    title: "Вход",
    email: "Имейл",
    password: "Парола",
    button: "Вход",
    orsign: "Или влезте с",
    forgot: "Забравена парола?",
    noaccount: "Нямате акаунт?",
    create: "Създайте тук",
    error: "Комбинацията имейл/парола е невалидна",
  },
  register: {
    title: "Създайте акаунт",
    name: "Пълно име",
    email: "Имейл",
    password: "Парола",
    passwordRetype: "Повторете паролата",
    button: "Създайте акаунт",
    orsign: "Или се регистрирайте с",
    agree: "С регистрацията си приемате",
    account: "Вече имате акаунт?",
    signin: "Вход",
  },
  utility: {
    maintenance: "В процес на поддръжка",
  },
  faq: {
    call: "Имате други въпроси? Моля, свържете се с нас ",
  },
  ecommerce: {
    products: "Продукти",
    filters: "Филтри",
    collections: "Колекции",
    priceRange: "Ценови диапазон",
    clientReviews: "Отзиви на клиенти",
    up: "и нагоре",
    brand: "Марка",
    search: "Търсене на продукт",
    results: "Резултати ( {0} от {1} )",
    orders: "Поръчки",
    shipping: "Доставка",
    freeShipping: "Безплатна доставка",
    inStock: "В наличност",
    quantity: "Количество",
    addToCart: "Добави в количката",
    buyNow: "Купи сега",
    price: "Цена",
    about: "За този артикул",
    description: "Описание",
    reviews: "Отзиви",
    details: "Детайли за продукта",
    cart: "Количка",
    summary: "Обобщение на поръчката",
    total: "Общо",
    discount: "Отстъпка",
    subtotal: "Междинна сума",
    continue: "Продължи с пазаруването",
    checkout: "Плащане",
  },
  menu: {
    rateManagement: "Управление на тарифи",
    reservation: "Резервация",
    reservationNew: "Нова",
    reservationList: "Списък",
    frontOffice: "Рецепция",
    generalSettings: "Общи настройки",
    guestTitle: "Титла на госта",
    guestDocumentType: "Тип документ на госта",
    manageHotel: "Хотел",
    hotel: "Хотел",
    hotelList: "Списък",
    hotelCategory: "Категория хотел",
    hotelChain: "Хотелска верига",
    marketSegment: "Пазарен сегмент",
    rooms: "Стаи",
    currency: "Валута",
    search: "Търсене (натиснете \"ctrl + /\" за фокус)",
    dashboard: "Табло",
    logout: "Изход",
    flushSiteData: "Изчисти данните на сайта",
    clearCache: "Изчисти кеша",
    profile: "Профил",
    blank: "Празна страница",
    pages: "Страници",
    others: "Други",
    email: "Имейл",
    chat: "Чат",
    todo: "Задачи",
    board: "Табло със задачи",
    users: "Потребители",
    usersList: "Списък",
    usersEdit: "Редактирай",
    ecommerce: "Електронна търговия",
    ecommerceList: "Продукти",
    ecommerceProductDetails: "Детайли за продукта",
    ecommerceOrders: "Поръчки",
    ecommerceCart: "Количка",
    auth: "Страници за удостоверяване",
    authLogin: "Вход / Вписване",
    authRegister: "Регистрация / Създаване на акаунт",
    authVerify: "Потвърди имейл",
    authForgot: "Забравена парола",
    authReset: "Нулиране на парола",
    errorPages: "Страници за грешки",
    errorNotFound: "Не е намерено / 404",
    errorUnexpected: "Неочаквано / 500",
    utilityPages: "Помощни страници",
    utilityMaintenance: "Поддръжка",
    utilitySoon: "Очаквайте скоро",
    utilityHelp: "ЧЗВ / Помощ",
    levels: "Нива на менюто",
    disabled: "Менюто е деактивирано",
    docs: "Документация",
    feedback: "Обратна връзка",
    support: "Поддръжка",
    history: "История",
  },
  localColumns: {
    defaultVatProductPostingGroup: "Стандартна група за ДДС на продукти",
    defaultWhtProductPostingGroup: "Стандартна група за удържан данък",
    postingGroup: "Група за осчетоводяване",
    postingType: "Тип осчетоводяване",
    inventoryPostingType: "Тип осчетоводяване на склад",
    isWitholdingTax: "С удържан данък",
    isNoVat: "Без ДДС",
    batchName: "Име на партида",
    batchCode: "Код на партида",
    totalRecords: "Общ брой записи",
    totalAmount: "Обща сума",
    totalDebit: "Общ дебит",
    totalCredit: "Общ кредит",
    journalName: "Име на журнал",
    company: "Компания",
    offsetCompany: "Офсет компания",
    offsetAccount: "Офсет сметка",
    isPom: "POM?",
    sentecAccountNo: "Sentec номер на сметка",
    sentecAccountName: "Sentec име на сметка",
    salesPersonName: "Име на търговец",
    guestAccountName: "Име на гост/акаунт",
    contactPersonName: "Име на контактно лице",
    creditLimit: "Кредитен лимит",
    remainingBalance: "Оставащ баланс",
    vleAmount: "Сума VLE",
    gleAmount: "Сума GLE",
    cleAmount: "Сума CLE",
    diff: "Разлика",
    SOHQuantity: "Количество SOH",
    IABQuantity: "Количество IAB",
    SOHTotalCost: "Обща стойност SOH",
    COAAmount: "Сума COA",
    costDifference: "Разлика в разходите",
    isGeneralStorage: "Общо съхранение",
    generalLedgerEntryId: "ID на запис в главната книга",
    operator: "Оператор",
    ilePostingDate: "Дата на публикуване ILE",
    receivableDate: "Дата на получаване",
    receivableDueDate: "Дата на падеж на вземане",
    receivablePostingDate: "Дата на записване на вземания",
  },
  localCommon: {
    noMenuMatchedWithSearchQuery: "Няма съвпадение на менюто с търсенето",
    top10VendorByBalance: "Топ 10 доставчици по баланс",
    top10ClientsByBalance: "Топ 10 клиенти по баланс",
    chooseTime: "Изберете време",
    top10PurchaseItem: "Топ 10 артикула за покупка",
    adjustEntry: "Коригирай запис",
    split: "Раздели",
    postBatch: "Осчетоводи партида",
    processing: "Обработка",
    generalLedgerBudget: "Бюджет на главната книга",
    inventory: "Склад",
  },
  coaIntegration: {
    title: "COA интеграция",
    titleMapping: "COA съпоставяне",
    provider: "Доставчик",
    dataLog: "Дневник на данните",
    flushDataLog: "Изчисти данните",
    successSaveConfig: "Конфигурацията е обновена",
    successGenerateData: "Данните са генерирани",
    successSendData: "Данните са обработени, моля, проверете отговора",
    successFlushData: "Дневникът на данните е изчистен",
    successUpdateMappingData: "Съпоставянето е обновено",
    successDeleteMappingData: "Съпоставянето е изтрито",
    inputSystemChartOfAccount: "Системна сметка на COA",
    deleteMappingConfirm: "Сигурни ли сте, че искате да изтриете този запис? този процес не може да бъде отменен.",
    deleteDataLogByMonthConfirm: "Сигурни ли сте, че искате да изтриете всички записи за избрания месец? този процес не може да бъде отменен.",
    deleteDataLogAllConfirm: "Сигурни ли сте, че искате да изтриете всички записи? този процес не може да бъде отменен.",
    baseUrl: "Основен URL",
  },
  $vuetify: {
    badge: "Значка",
    close: "Затвори",
    dataIterator: {
      noResultsText: "Няма намерени съвпадащи записи",
      loadingText: "Зареждане на елементи...",
    },
    dataTable: {
      itemsPerPageText: "Редове на страница:",
      ariaLabel: {
        sortDescending: "Сортирано низходящо.",
        sortAscending: "Сортирано възходящо.",
        sortNone: "Не е сортирано.",
        activateNone: "Активирай за премахване на сортирането.",
        activateDescending: "Активирай за сортиране низходящо.",
        activateAscending: "Активирай за сортиране възходящо.",
      },
      sortBy: "Сортирай по",
    },
    dataFooter: {
      itemsPerPageText: "Елементи на страница:",
      itemsPerPageAll: "Всички",
      nextPage: "Следваща страница",
      prevPage: "Предишна страница",
      firstPage: "Първа страница",
      lastPage: "Последна страница",
      pageText: "{0}-{1} от {2}",
    },
    datePicker: {
      itemsSelected: "{0} избрани",
      nextMonthAriaLabel: "Следващ месец",
      nextYearAriaLabel: "Следваща година",
      prevMonthAriaLabel: "Предишен месец",
      prevYearAriaLabel: "Предишна година",
    },
    noDataText: "Няма налични данни",
    carousel: {
      prev: "Предишен изглед",
      next: "Следващ изглед",
      ariaLabel: {
        delimiter: "Слайд {0} от {1}",
      },
    },
    calendar: {
      moreEvents: "Още {0}",
    },
    fileInput: {
      counter: "{0} файла",
      counterSize: "{0} файла ({1} общо)",
    },
    timePicker: {
      am: "AM",
      pm: "PM",
    },
    pagination: {
      ariaLabel: {
        wrapper: "Навигация за странициране",
        next: "Следваща страница",
        previous: "Предишна страница",
        page: "Към страница {0}",
        currentPage: "Текуща страница, страница {0}",
      },
    },
  },
  generalLedgerBudget: {
    editTitle: "Редактиране на бюджет",
    title: "Импорт от XLS",
    successImportData: "Данните са импортирани!",
  },
  balanceSheetConsolidation: {
    title: "Консолидация на баланса",
    titleReport: "Доклад за консолидиране на баланса",
    excelFileID: "ИД на Excel файл за консолидиране на балансов отчет",
    sheetFileID: "ID на файл за консолидиране на балансова ведомост в Google Sheets",
  },
  userPostingSetup: {
    setPostingDate: "Настрой дата на публикуване за всички потребители",
  },
  purchaseRequisitionBatch: {
    allowedApprovalSubmissionDays: "Разрешени дни за подаване на одобрение",
  },
  documentFlow: {
    purchaseInvoiceDefaultDocumentFlow: "Стандартен документен поток за фактура за покупка",
    purchaseInvoiceDocumentFlowRules: "Правила за поток на документация за фактури",
    equal: "Равно",
    notEqual: "Не равно",
    lessThan: "По-малко от",
    lessThanOrEqual: "По-малко или равно",
    greaterThan: "По-голямо от",
    greaterThanOrEqual: "По-голямо или равно",
    purchaseOrderDocumentFlowRules: "Правила за потока на документи за поръчка за покупка",
    purchaseReceiptDocumentFlowRules: "Правила за потока на документи за разписка за покупка",
    default: "По подразбиране поток на документи",
    purchaseOrderDMLDocumentFlowRules: "Правила за потока на документи за поръчка за покупка по Дневен Пазарен Списък",
    documentsSourceInformation: "Документите на тази страница са изключително от Back Office (напр. PI, PO, PR и др.). Документите, генерирани от Front Office, могат да се видят в модула Front Office.",
    refreshApprovals: "Обнови одобренията",
    showInformation: "Покажи информация",
    submitForApprovalConfirmation: "Заявките за одобрение ще бъдат изпратени по имейл на тези потребители. Моля, уверете се, че информацията е правилна.",
    hideInformation: "Скрий информацията",
    documentFlowBeingUsed: "Използван поток на документи",
    sendEmail: "Изпрати имейл",
    sendReminder: "Изпрати напомняне",
    reminderCount: "Брой напомняния",
    remindedAt: "Напомнено на",
  },
  changesLog: {
    logCategory: "Категория на логовете",
    sourceId: "ID на източника",
  },
  taxSubmission: {
    availableToCancelOrReject: "Наличен за анулиране/отхвърляне",
    availableToGetSubmittedDetails: "Налични за получаване на подадени детайли",
    availableToSend: "Наличен за изпращане",
    buyerAddress: "Адрес на купувача",
    buyerContractName: "Име на договора на купувача",
    buyerName: "Име на купувача",
    buyerRegistrationNumber: "Номер на регистрация на купувача",
    buyerSSTRegistrationID: "ИД за регистрация на купувача по SST",
    buyerTIN: "Данъчен номер на купувача",
    classification: "Класификация",
    eInvoice: "електронна фактура",
    eInvoiceCode: "Код за е-фактура",
    eInvoiceType: "Тип e-фактура",
    eInvoiceVersion: "Версия на e-фактурата",
    invoiceDateAndTime: "Дата и час на фактурата",
    originalInvoiceRefNo: "Оригинален номер на фактура: Не е приложимо",
    sendCountInvoicesToTaxInterface: "Изпратете {count} фактури на данъчния интерфейс",
    subtotal: "Междинна сума",
    supplierBusinessActivityDescription: "Описание на дейността на доставчика",
    supplierMSICCode: "Код на доставчика MSIC",
    supplierRegistrationNumber: "Номер на регистрация на доставчика",
    supplierSSTID: "ИД на доставчика по ДДС",
    supplierTIN: "Данъчен номер на доставчика",
    taxRate: "Данъчна ставка",
    totalExcludingTax: "Обща сума без данък",
    totalIncludingTax: "Обща сума с данък",
    totalPayableAmount: "Обща дължима сума",
    uniqueIdentifierNo: "Уникален идентификатор №",
    unitPrice: "Цена за единица",
    digitalSignature: "Цифров подпис",
    validationDateTime: "Дата и час на валидиране",
    visualPresentation: "Този документ е визуално представяне на електронната фактура",
    na: "Н/А",
    getSubmittedDocumentURL: "Вземи URL на подадения документ",
    cancelOrRejectDocument: "Откажи или отхвърли документа",
    interfaceStatus: "Статус на интерфейса",
    receiptVerificationRedirectURL: "URL за пренасочване към проверка на разписка",
    receiptVerificationSubmissionUUID: "UUID за подаване на проверка на разписка",
    receiptVerificationDocumentUUID: "UUID на документа за проверка на разписка",
    reject: "Отхвърли",
  },
  template: {
    columnLengthDifference: "Невалиден шаблон: броят на колоните не съвпада.",
  },
  radio: {
    autoclose: "Автоматично затваряне",
    manualclose: "Ръчно затваряне",
  },
  cashFlowBudget: {
    editTitle: "Редактиране на бюджет",
    title: "Импорт от XLS",
    successImportData: "Данните са импортирани!",
  },
}
